/* eslint no-redeclare: "off" */

import $ from 'jquery';
import * as _ from 'lodash';
import { fabric } from './fabric';
import {
  findSectorPointByAngle,
  getColorUpdate,
  isEnableToolStyle,
  intersectionPointOfCircleAndLine,
  util,
} from './util';
import { ui } from './ui';
import { historyFilo } from './history';
import { userinfo } from './userinfo';
import {
  isPrimaryCompany,
  isLoginUserPartnerCompany,
} from '../../utilities/roleUtility';
import { API } from '../../utilities/constants';
import { imageObjectSetScale } from '../../utilities/imageUtility';
import { headReplace } from '../../utilities/stringUtil';
import { isIPad } from '../../utilities/commonUtil';
import { split } from '../constructionPlacement/split';
import { AirTwoTone } from '@mui/icons-material';
import {
  canRedoPen,
  canUndoPen,
  defaultColor,
  defaultStrokeSize,
  finalizeStroke,
  freehandEnd,
  freehandMove,
  freehandStart,
  penEnd,
  penStart,
  updateCustomFreehandColor,
  updateFreehandGroupThickness
} from './freehandUtil';

function _drawing() {
  // カーソルのURL
  this.pointerUrl = '/drawing/cursor/pointer24.png';
  this.pointerUrl_IE = '/drawing/cursor/pointer24_1.cur';
  this.arrowPointerUrl = '/drawing/cursor/arrow_pointer.png';
  this.arrowPointerUrl_IE = '/drawing/cursor/arrow_pointer_1.cur';

  this._MAX_TOP = 650;
  this._MAX_LEFT = 1000;
  this._MIN_TOP = 0;
  this._MIN_LEFT = 0;

  this._shapes = [
    'egEllipse',
    'egRect',
    'egPolygon',
    'egSector',
  ];

  this._canvas = undefined;

  // Canvasで、選択中のオブジェクト
  this._target = undefined;

  // 選択中のステータス
  this._select_one = false;
  this._select_multi = false;
  this._select_group = false;

  // 作成中のオブジェクト
  this._making = undefined;

  // イベントが発生した位置
  this._pos = undefined;
  this._posSelStart = undefined;
  this._posSelEnd = undefined;
  this._dragPos = undefined;

  // 前回のマウス移動イベント
  this._lastMouseMoveEvent = undefined;

  // オブジェクトの操作状態
  this._rotating = false;
  this._gesture = false;

  // ツールボックスで選択されているツール
  this._toolbox_selected = 'tool-select';

  // ツールバーで選択されている値
  this._toolbar_border = 1;
  this._toolbar_border_style = [1, 0];
  this._toolbar_picker_foreground = '#111111';
  this._toolbar_picker_background = 'white';
  this._toolbar_picker_text = '#111111';
  this._toolbar_font_size = '11';
  this._toolbar_arrow_type = 0;
  this._toolbar_arrow_size = 10;

  // 部品
  this._parts_scale = 1.0;
  this._parts_url = '';

  // クリップボード
  this._clip = null;
  this._clipOrder = [];
  this._clipRoomId = '';
  this._offset = 20;

  // undo/redo
  // this._is_undo = false;
  // this._undoing = false;

  // gesture
  this._startZoom = 1;
  this._save_toolbox_selected = '';

  // zoom
  this._zoom = 1.0;

  this.historyTool = 'tool-pan';

  // 左のオフセット
  // 初期化時に決定し定数的に利用する
  this.leftOffset = util.getLeftOffset();
  // console.log('leftOffset', this.leftOffset);

  this.backgroundPrint = new fabric.EgRect({
    strokeWidth: 0,
    fill: 'white',
    hasBorders: false,
    hasControls: false,
    selectable: false,
    evented: false,
    globalCompositeOperation: 'destination-over',
    excludeFromExport: true, // Jsonにした際に除外する
    neverSelectable: true, //selectable=trueにはしない
  });
  // オブジェクトの最大配置数
  this._object_max_count = 500;
  // オブジェクト残数わずかの警告表示個数(設定値になると表示)
  this._object_warning_remain_count = 20;
  this.stateProperties = {
    stateProperties: [
      'rx',
      'ry',
      'path',
      'pathOffset',
      'points',
      'arrowSize',
      'arrowStart',
      'arrowEnd',
      'x1',
      'x2',
      'y1',
      'y2',
      'strokeSize',
      'strokeColor'
    ],
  };
  this.managerLockedProperty = {
    cornerSize: 14,
    borderColor: 'rgba(255,50,50,0.8)',
    cornerColor: 'rgba(255,50,50,0.8)',
    // 赤
  };
  this.foremanLockedProperty = {
    cornerSize: 14,
    borderColor: 'rgba(255,50,255,0.8)',
    cornerColor: 'rgba(255,50,255,0.8)',
    // 紫
  };
  this.unLockedProperty = {
    cornerSize: 14,
    borderColor: 'rgba(100,150,255,0.9)',
    cornerColor: 'rgba(100,150,255,0.9)',
  };

  this.client = null;
  this.places = null;
  this.split = null;

  this.limitRotationDegree = 45;
  this.shortcutRotationDegree = 15;
  this.minZoom = 0.25;
  this.maxZoom = 8;

  // 描画ツール
  this.freehandState = {
    isDrawing: false,
    points: [],
    allPoints: [],
    tempPaths: [],
    color: defaultColor,
    strokeSize: defaultStrokeSize,
    redoStack: [],
  }
}

_drawing.prototype.initCursor = function() {
  this.cursor = {
    pointer: `url(${ui.isIE() ? this.pointerUrl_IE : this.pointerUrl})`,
    arrow: `url(${ui.isIE() ? this.arrowPointerUrl_IE : this.arrowPointerUrl})`,
  };
};

// 初期化
_drawing.prototype.setCanvas = function(id) {
  var self = this;

  // キャンバス初期設定
  self._canvas = new fabric.Canvas(id, {
    preserveObjectStacking: true,
    renderOnAddRemove: false,
    selectionFullyContained: true,
    targetFindTolerance: 2,
  });

  self.initCursor();

  self._canvas.selectionColor = 'rgba(0,0,255,0.05)'; // 選択範囲の塗り色
  self._canvas.selectionBorderColor = '#666'; // 選択時の枠線色
  self._canvas.selectionLineWidth = 1; // 選択時の枠線太さ
  self._canvas.selectionDashArray = [2, 2]; // 選択時の枠線パターン

  self._canvas._isUniscalePossible = function(e, target) {
    return (
      (!e[this.uniScaleKey] || this.uniScaleTransform) &&
      !target.get('lockUniScaling')
    );
  };

  // correct IPAD layout when orientation changed
  window.addEventListener(
    'orientationchange',
    function() {
      if (self._canvas) {
        setTimeout(() => {
          self._canvas.calcOffset();
          const headerHeight = self.client.getHeaderHeight(drawing._canvasLock);
          const relativePoint = self.client.getRelativePoint(headerHeight);
          self._canvas.relativePan(
            new fabric.Point(relativePoint.x, relativePoint.y)
          );
          self._canvas.requestRenderAll();
          ui.correctLayoutFooter(ui._fullScreen);
          ui.resizeHeader(window.innerHeight > window.innerWidth);
        }, 200);
      }
    },
    false
  );
  // Canvasイベント
  // オブジェクトの回転
  self._canvas.on('object:rotating', function() {
    self._rotating = true;
  });

  // オブジェクトの回転時
  self._canvas.on('object:rotating', function(e) {
    if (e.e.shiftKey) {
      // Rotating from current angle to one of 0, 45, 90 ... depending on which is closer
      // Base on function : fabric.Object.prototype.straighten, /node_modules/fabric/src/mixins/object_straightening.mixin.js
      let _getAngleValueForStraighten = function() {
        let angle = self._target.angle % 360;
        if (angle > 0) {
          return (
            Math.round((angle - 1) / self.limitRotationDegree) *
            self.limitRotationDegree
          );
        }
        return (
          Math.round(angle / self.limitRotationDegree) *
          self.limitRotationDegree
        );
      };
      self._target.rotate(_getAngleValueForStraighten());
    }
  });

  // オブジェクト変更
  self._canvas.on('object:modified', function(e) {
    console.log('debug', 'object:modified', 'start');
    // 修正前保持用
    var drawObject = null;
    // 修正後保持用（egPolyLine, egPolygonのみ想定）
    var afterModifyObject = null;
    if (self._toolbox_selected === 'tool-print-range') {
      return;
    }
    var history = self.historyInit();
    if (
      (self._select_one && !(self._target && self._target._objects)) ||
      (self._select_one && self._target && self._target.type === 'customFreehand') ||
      self._select_group
    ) {
      var _push = function(t, top_flag, isGroup) {
        var msg = {
          action: 'move',
          uuid: t.uuid,
          isGroup,
          top: t.top,
          left: t.left,
          flipX: t.flipX,
          flipY: t.flipY,
          width: t.width,
          height: t.height,
          scaleX: t.scaleX,
          scaleY: t.scaleY,
          angle: t.angle,
          originX: t.originX,
          originY: t.originY,
        };
        if (
          t.type === 'egPolyline' ||
          t.type === 'egPolygon' ||
          t.type === 'egSector'
        ) {
          msg['points'] = t.points;
        }
        if (t.type === 'egGroup') {
          _.each(t._objects, function(object) {
            _push(object, false, true);
          });
        }
        self.client.push(msg);
        if (top_flag) {
          self.historyPush(t, history, {});
        }
        console.log('debug', `object modified uuid:${t.uuid} (${t.type}).`);
      };
      if (self._target.isEditPoint) {
        // 編集マーカーの場合、親オブジェクトを保持
        drawObject = self._target.poly;
        drawObject.update();
        switch (drawObject.type) {
          case 'egSector':
          case 'egLine':
          case 'egPolygon':
          case 'egPolyline':
            // 修正後のオブジェクトが戻るのでそれを保持
            afterModifyObject = self.handleEgObject(drawObject);
            self._target = afterModifyObject;
            _push(afterModifyObject, true);
            self._target.update();
            self.removeEditPoints();
            if (checkObjectCount(self._canvas)) {
              self._canvas.setActiveObject(afterModifyObject);
            }
            self._canvas.fire('mouse:dblclick', { target: afterModifyObject });
            break;
          default:
            break;
        }
      } else {
        self._target.setCoords();
        self._target.update();
        self._target.sx = self._target.scaleX;
        self._target.sy = self._target.scaleY;
        self._target.resizeToScale();
        _push(self._target, true, false);
      }
      self.client.flush();
    }
    if (
      self._select_multi ||
      (self._target && self._target._objects && !self._select_group && self._target.type !== 'customFreehand')
    ) {
      {
        var group = self._target;
        _.each(group._objects, function(object) {
          object.sx = group.scaleX;
          object.sy = group.scaleY;
          if (object.type === 'egSector') {
            object.sx = object.sy = Math.min(group.scaleX, group.scaleY);
          }
          object.left *= group.scaleX;
          object.top *= group.scaleY;
          object.setCoords();
          object.update();

          if (object.type === 'egText') {
            object.scaleX *= group.scaleX;
            object.scaleY *= group.scaleY;
          } else if (object.type === 'egImage') {
            object.resizeToScale(group.scaleX, group.scaleY, false, true);
          } else {
            object.resizeToScale(group.scaleX, group.scaleY);
          }
        });
        group.width *= group.scaleX;
        group.height *= group.scaleY;
        group.scaleX = 1;
        group.scaleY = 1;

        var _push = function(group, t, isGroup) {
          if (!isGroup) {
            var center = group.getCenterPoint();
            var rad = fabric.util.degreesToRadians(group.angle);
            var point = fabric.util.rotatePoint(
              new fabric.Point(t.left, t.top),
              new fabric.Point(0, 0),
              rad
            );
            var flipX = t.flipX;
            var flipY = t.flipY;
            var left = center.x + point.x;
            var top = center.y + point.y;
            if (group.flipX) {
              flipX = !t.flipX;
              left = center.x - point.x;
              if (t.type !== 'egGroup') {
                left -= t.width;
              }
            }
            if (group.flipY) {
              flipY = !t.flipY;
              top = center.y - point.y;
              if (t.type !== 'egGroup') {
                top -= t.height;
              }
            }
            var msg = {
              action: 'move',
              uuid: t.uuid,
              top,
              left,
              scaleX: group.scaleX * t.scaleX,
              scaleY: group.scaleY * t.scaleY,
              width: t.width,
              height: t.height,
              flipX,
              flipY,
              angle: group.angle + t.angle,
              originX: t.originX,
              originY: t.originY,
              isGroup,
            };
          } else {
            var msg = {
              action: 'move',
              uuid: t.uuid,
              isGroup,
              top: t.top,
              left: t.left,
              flipX: t.flipX,
              flipY: t.flipY,
              width: t.width,
              height: t.height,
              scaleX: t.scaleX,
              scaleY: t.scaleY,
              angle: t.angle,
              originX: t.originX,
              originY: t.originY,
            };
          }
          if (t.type === 'egPolyline' || t.type === 'egPolygon') {
            msg['points'] = t.points;
          }
          if (t.type === 'egPath') {
            msg['path'] = t.path;
            msg['pathOffset'] = t.pathOffset;
          }
          if (t.type === 'egEllipse') {
            if (t.rx === 0) {
              t.rx = 0.1;
            }
            if (t.ry === 0) {
              t.ry = 0.1;
            }
            msg.rx = t.rx;
            msg.ry = t.ry;
          }
          if (t.type === 'egLine') {
            msg.x1 = t.x1;
            msg.x2 = t.x2;
            msg.y1 = t.y1;
            msg.y2 = t.y2;
          }
          if (t.type === 'egGroup') {
            _.each(t._objects, function(object) {
              _push(t, object, true);
            });
          }
          self.client.push(msg);
          if (!isGroup) {
            self.historyPush(t, history, {
              top,
              left,
              angle: group.angle + t.angle,
              flipX,
              flipY,
            });
          }
          console.log('debug', 'object:modified', 'uuid:', t.uuid, t.type);
        };
        _.each(group._objects, function(object) {
          _push(group, object, false);
        });
        self.client.flush();
      }
    }
    self.historySet('modify', history);
    self.setSelection();
    ui.checkDisableMoveFrontOrBack(self._canvas, e.target);
    //BLDE_V2-16873対応 >>>------------------------------------------------
    //修正後オブジェクトがあれば（egPolyLine, egPolygonでの編集マーカーを使っての修正）
    // if (afterModifyObject != null) {
    //   //選択線削除
    //   self.removeVertices(true, null);
    //   //操作ターゲットを新オブジェクトに変更
    //   self._target = afterModifyObject;
    //   //修正後のオブジェクトをアクティブにする
    //   self._canvas.setActiveObject(afterModifyObject);
    //   //修正前のオブジェクトを削除
    //   self._canvas.remove(drawObject);
    //   //ダブルクリックイベント発火で編集マーカーを表示する
    //   self._canvas.fire('mouse:dblclick', { target: afterModifyObject });
    // }
    //編集マーカーを表示して、編集処理をできるようにする修正は、すんなりいったのですが、
    //同一編集マーカーで修正を行うとエラーになり、編集後の内容で描画すらできない状態だった。
    //それを修正するために、色々試した結果、上記のような対応にしました。
    //本来であれば、内部で保持しているオブジェクトの状態が常に更新され最新になっているのが理想だが、
    //V2に入ってからの修正によるものなのか、同期がとれていない模様。時間的な都合から（言い訳w）
    //上記なような修正とさせていただきました。
    //<<<-----------------------------------------------------------------
    console.log('debug', 'object:modified', 'end');
  });

  // BLDE_V2-49051 マウスがキャンバスから他の要素に移動しても、IMEのドロップダウンが消えないように
  function handleMouseDown() {
    self._canvas.fire('mouse:down', {
      e: new MouseEvent('mousedown'),
    });
  }
  self._canvas.on('text:editing:exited', () => {
    self._canvas.upperCanvasEl.style.zIndex = '';
    self._canvas.lowerCanvasEl.removeEventListener(
      'mousedown',
      handleMouseDown
    );
  });
  self._canvas.on('text:editing:entered', e => {
    if (!e.target || e.target.locked) {
      // If the object is locked, do not proceed with the event handler
      return;
    }
    self._canvas.upperCanvasEl.style.zIndex = '-1';
    self._canvas.lowerCanvasEl.addEventListener('mousedown', handleMouseDown);
  });

  self._canvas.on('object:moving', function(e) {
    if (!e.target || !e.target.isEditPoint) {
      return;
    }
    self.changeLines(e.target);
  });
  function handleSelection(self, e) {
    const numberOfSelectedObject = self._canvas.getActiveObjects().length;
    if (numberOfSelectedObject === 0) {
      self._target = undefined;
      self._select_one = false;
      self._select_multi = false;
      self._select_group = false;
      self._rotating = false;
      self.updateScreen();
      return;
    }
    if (numberOfSelectedObject === 1) {
      self._target = self._canvas.getActiveObject();
      self._select_one = true;
      self._select_multi = false;
      self._select_group = self._target.type === 'egGroup';
      self._target.saveState(self.stateProperties);
    } else {
      self._target = e.target;
      self._select_one = false;
      self._select_multi = true;
      self._select_group = false;
      _.each(self._target._objects, object => {
        if (object && _.isUndefined(object._stateProperties)) {
          object.saveState(self.stateProperties);
          const objectProperties = self.getObjectPropertiesInGroup(
            self._target,
            object
          );
          _.merge(object._stateProperties, objectProperties);
        }
      });
    }
  }

  self._canvas.on('selection:updated', function(e) {
    console.log('debug', 'selection:updated', 'start');
    self._canvas.forEachObject(function(o) {
      // BLDE_V2-27371 線のオブジェクトがバウンディングボックスではなく、ピクセルごとにキャンバス上で「検出」されるため
      if (['egPolyline', 'egLine', 'egPath'].includes(o.type)) {
        o.perPixelTargetFind = true;
      }
      if (o.type === 'egSector') {
        o.lockUniScaling = true;
      }
    });
    handleSelection(self, e);
    self.updateScreen();
    ui.checkToolToDisable(e.target.type);
    ui.checkDisableMoveFrontOrBack(self._canvas, e.target);
    ui.enableToolStyleSwipeObject(self._target);
    let statuses = self.getSelectionStatus(self._target);
    let { isSelectOneGroup } = statuses;
    if (isSelectOneGroup) {
      ui.styleWithGroupLocked(statuses);
    }
    ui.checkDisableToolLineSize();
    ui.styleWithTargetLocked(statuses, self._target);
    console.log('debug', 'selection:updated', 'end');
  });

  self._canvas.on('selection:created', function(e) {
    console.log('debug', 'selection:created', 'start');
    if (e.target === undefined) {
      return;
    }
    handleSelection(self, e);
    self.updateScreen();
    ui.checkToolToDisable(e.target.type);
    ui.checkDisableMoveFrontOrBack(self._canvas, e.target);
    ui.enableToolStyleSwipeObject(self._target);
    let statuses = self.getSelectionStatus(self._target);
    let {
      isSelectOneGroup,
      isSelectMultiAllLock,
      isSelectMultiAnyLock,
    } = statuses;
    if (isSelectOneGroup || isSelectMultiAllLock || isSelectMultiAnyLock) {
      ui.styleWithGroupLocked(statuses);
    }
    ui.checkDisableToolLineSize();
    ui.styleWithTargetLocked(statuses, self._target);
    console.log('debug', 'selection:created', 'end');
  });

  self._canvas.on('selection:cleared', function(e) {
    console.log('debug', 'selection:cleared', 'start');
    self.removeEditPoints();
    self._canvas.forEachObject(function(o) {
      o.hasBorders = o.hasControls = true;
      o.objectCaching = false;
      // BLDE_V2-27371 線のオブジェクトがバウンディングボックスではなく、ピクセルごとにキャンバス上で「検出」されるため
      if (['egPolyline', 'egLine', 'egPath'].includes(o.type)) {
        o.perPixelTargetFind = true;
      }
      if (o.type === 'egSector') {
        o.lockUniScaling = true;
      }
    });
    if (self._toolbox_selected === 'tool-print-range') {
      // 印刷範囲フレームしか選択させないために下記のコードを
      // setTimeoutを使って遅延実行しないと正常動作しない
      setTimeout(() => {
        if (self._toolbox_selected !== 'tool-print-range') {
          return;
        }
        var objectCount = self._canvas.getObjects().length;
        if (objectCount > 0) {
          const printFrame = self.findPrintFrame(self._canvas.getObjects());
          if (checkObjectCount(self._canvas) && printFrame) {
            self._canvas.setActiveObject(printFrame);
          }
        }
      }, 10);

      return;
    }
    if (typeof e.e === 'undefined') {
      self.removeVertices(true, self._toolbox_selected);
    } else {
      self.removeVertices(true, null);
    }

    self._target = undefined;
    self._select_one = false;
    self._select_multi = false;
    self._select_group = false;
    self._rotating = false;
    if (!split._splited) {
      self.updateScreen();
    }
    $('.tool-setting-style').removeClass('pointer-events-none');
    console.log('debug', 'selection:cleared', 'end');
  });

  self._canvas.on('after:render', () => {
    if (self._currentPolygonUuid) {
      if (checkObjectCount(self._canvas)) {
        self._canvas.setActiveObject(
          fabric.eg.getFromUuid(self._currentPolygonUuid)
        );
        self.updateScreen();
        self._canvas.requestRenderAll();
      }
      self._currentPolygonUuid = undefined;
    }
    self._canvas.forEachObject(obj => {
      obj.setCoords();
    });
  });

  // オブジェクト選択時
  self._canvas.on('object:selected', function(e) {
    console.log('debug', 'object:selected', 'start', e.target.evented);
    if (!e.target.evented) {
      return;
    }
    if (self._toolbox_selected === 'tool-print-range') {
      return;
    }

    self._target = e.target;

    self._select_one = true;
    self._select_multi = false;
    self._select_group = self._target.type == 'egGroup';
    self._rotating = false;
    self._target.saveState(self.stateProperties);
    self.updateScreen();

    if (e.target.type === 'egPolyline') {
      let points = e.target._stateProperties.points;
      self._target._stateProperties.points = [];
      for (let i = 0; i < points.length; i++) {
        let p = points[i];
        self._target._stateProperties.points.push({ x: p.x, y: p.y });
      }
    }
    // BLDE_V2-27371 オブジェクトが選択されている場合、オブジェクトを遷移するためperPixelTargetFindは「false」に設定する
    if (
      self._target.type &&
      ['egPolyline', 'egLine', 'egPath'].includes(self._target.type)
    ) {
      self._target.perPixelTargetFind = false;
    }
    if (self._target.type === 'egSector') {
      self._target.lockUniScaling = true;
    }

    ui.checkToolToDisable(e.target.type);
    ui.checkDisableMoveFrontOrBack(self._canvas, e.target);
    ui.enableToolStyleSwipeObject(self._target);
    let statuses = self.getSelectionStatus(self._target);
    let { isSelectOneGroup } = statuses;
    if (isSelectOneGroup) {
      ui.styleWithGroupLocked(statuses);
    }
    ui.checkDisableToolLineSize();
    ui.styleWithTargetLocked(statuses, self._target);
    console.log('debug', 'object:selected', 'end');
  });

  self._canvas.on('path:created', function(e) {
    console.log('debug', 'path:created', 'start');
    self._canvas.discardActiveObject();
    e.path.clone(function(path) {
      let o = fabric.util.object.extend(path.toObject(), null);
      delete o.type;
      o.selectable = false;
      o.originX = 'left';
      o.originY = 'top';
      let p = fabric.EgPath.fromObject(o);
      //一定以上の描写のみ反映させる
      if (p.path.length > 5) {
        self._canvas.add(p);
        self.client.push({
          action: 'add',
          objects: [p.toObject()],
        });
        self.client.flush();
        var history = self.historyInit();
        self.historyPush(p, history);
        self.historySet('add', history);
        ui.toolboxSelect('tool-select');
        if (checkObjectCount(self._canvas)) {
          self._canvas.setActiveObject(p);
          self._canvas.requestRenderAll();
          const uuid = p.uuid;
          fabric.eg.setUuid(p, uuid);
          self._canvas.setActiveObject(fabric.eg.getFromUuid(uuid));
        }
      }
    });
    self._canvas.remove(e.path);
    console.log('debug', 'path:created', 'end');
  });
  // Remove event touchstart
  let addEventOptions = { passive: false };
  fabric.util.removeListener(
    self._canvas.upperCanvasEl,
    'touchstart',
    self._canvas._onTouchStart,
    addEventOptions
  );
  // Add event touchstart without e.preventDefault();
  // Fix dropdown items not hide after click on canvas
  let _onTouchStart = function(e) {
    let _this = self._canvas;
    if (_this.mainTouchId === null) {
      _this.mainTouchId = _this.getPointerId(e);
    }
    _this.__onMouseDown(e);
    _this._resetTransformEventData();
    let canvasElement = _this.upperCanvasEl,
      eventTypePrefix = _this._getEventPrefix();
    fabric.util.addListener(
      fabric.document,
      'touchend',
      _this._onTouchEnd,
      addEventOptions
    );
    fabric.util.addListener(
      fabric.document,
      'touchmove',
      _this._onMouseMove,
      addEventOptions
    );
    // Unbind mousedown to prevent double triggers from touch devices
    fabric.util.removeListener(
      canvasElement,
      `${eventTypePrefix}down`,
      _this._onMouseDown
    );
  };
  fabric.util.addListener(
    self._canvas.upperCanvasEl,
    'touchstart',
    _onTouchStart,
    addEventOptions
  );

  // display/hide controls on double tab touch devices
  fabric.util.addListener(self._canvas.upperCanvasEl, 'touchstart', tapHandler);
  let tapedTwice = false;
  function tapHandler(event) {
    if (!tapedTwice) {
      tapedTwice = true;
      setTimeout(function() {
        tapedTwice = false;
      }, 300);
      return false;
    }
    //action on double tap goes below
    let target = self._canvas._target;
    self._canvas.fire('touch:doubletap', {
      target,
      event,
    });
  }

  // submit text on tab touch devices
  self._canvas.on('touch:drag', function() {
    if (self._toolbox_selected === 'tool-select') {
      self._canvas.fire('mouse:down', {
        target: self._target,
      });
    }
  });

  self._canvas.on('mouse:over', function() {
    if (
      self._toolbox_selected === 'tool-pointer' ||
      self._toolbox_selected === 'tool-arrow-pointer'
    ) {
      return;
    }
    if (
      self._toolbox_selected !== 'tool-select' &&
      self._toolbox_selected !== 'tool-pan'
    ) {
      self._canvas.hoverCursor = 'crosshair';
      self._canvas.requestRenderAll();
    }
    if (self._toolbox_selected === 'tool-select') {
      self._canvas.defaultCursor = 'crosshair';
      self._canvas.hoverCursor = 'move';
      self._canvas.requestRenderAll();
    }
  });

  // ダブルクリック時
  self._canvas.on('mouse:dblclick', function(e) {
    console.log('debug', 'mouse:dblclick', 'start');

    if (self._canvas.getActiveObject()) {
      self.showEditPoints(e);
      return;
    }

    if (self._making) {
      switch (self._toolbox_selected) {
        case 'tool-polyline':
        case 'tool-polygon':
          self.addPoly();
          break;
      }
    }

    console.log('debug', 'mouse:dblclick', 'end');
  });

  self._canvas.on('touch:doubletap', function(e) {
    console.log('debug', 'touch:doubletap', 'start');

    self.showEditPoints(e);

    console.log('debug', 'touch:doubletap', 'end');
  });

  self._canvas.on('mouse:down', function(e) {
    console.log('debug', 'mouse:down', 'start');

    if (e.e && e.e.which === 3) {
      // 右クリック時の処理
      return;
    }
    switch (self._toolbox_selected) {
      case 'tool-point':
        if (
          e.target === null ||
          typeof e.target === 'undefined' ||
          !e.target.isEditPoint
        ) {
          self.removeVertices(true, null);
          self.removeEditPoints();
        } else {
          self.drawVirtualLines(e.target);
        }
        break;
      case 'tool-select':
      case 'tool-pan':
        var pos = self._canvas.getPointer(e.e);
        self._pos = pos;
        self._posSelStart = pos;
        if (fabric.eg._drawing.currentItextUuid) {
          const element = fabric.eg.getFromUuid(
            fabric.eg._drawing.currentItextUuid
          );
          element.submitText();
        }
        self._canvas.requestRenderAll();
        console.log('debug', 'mouse:down', 'point', pos.x, pos.y);
        break;

      case 'tool-line-normal':
        var pos = self._canvas.getPointer(e.e);
        var as = self._toolbar_arrow_type == 2 || self._toolbar_arrow_type == 3;
        var ae = self._toolbar_arrow_type == 1 || self._toolbar_arrow_type == 3;
        self._making = new fabric.EgLine([pos.x, pos.y, pos.x, pos.y], {
          stroke: self._toolbar_picker_foreground,
          strokeWidth: self._toolbar_border,
          strokeDashArray: self._toolbar_border_style,
          arrowStart: as,
          arrowEnd: ae,
          arrowSize: self._toolbar_arrow_size,
          selectable: false,
          objectCaching: false,
        });
        self._canvas.add(self._making);
        self._canvas.requestRenderAll();
        break;

      case 'tool-square':
        var pos = self._canvas.getPointer(e.e);
        self._pos = pos;
        self._making = new fabric.EgRect({
          left: pos.x,
          top: pos.y,
          height: 0,
          width: 0,
          fill: self._toolbar_picker_background,
          stroke: self._toolbar_picker_foreground,
          strokeWidth: self._toolbar_border,
          strokeDashArray: _.isEqual(self._toolbar_border_style, [1, 0])
            ? []
            : self._toolbar_border_style,
          selectable: false,
        });
        self._canvas.add(self._making);
        self._canvas.requestRenderAll();
        break;

      case 'tool-circle':
        var pos = self._canvas.getPointer(e.e);
        self._pos = pos;
        // 大きさの初期値(height,width,rx,ry)は画面上に見える程度にする
        self._making = new fabric.EgEllipse({
          left: pos.x,
          top: pos.y,
          height: 2,
          width: 2,
          rx: 1,
          ry: 1,
          fill: self._toolbar_picker_background,
          stroke: self._toolbar_picker_foreground,
          strokeWidth: self._toolbar_border,
          strokeDashArray: self._toolbar_border_style,
          selectable: false,
          objectCaching: false,
        });
        self._canvas.add(self._making);
        self._canvas.requestRenderAll();
        break;

      case 'tool-polyline':
      case 'tool-polygon':
        var pos = self._canvas.getPointer(e.e);
        if (!self._making) {
          var points = [
            {
              x: 0,
              y: 0,
            },
            {
              x: 0.5,
              y: 0.5,
            },
          ];
          var options = {
            top: pos.y,
            left: pos.x,
            fill: 'rgba(255,255,255,0)',
            stroke: self._toolbar_picker_foreground,
            strokeWidth: self._toolbar_border,
            strokeDashArray: _.isEqual(self._toolbar_border_style, [1, 0])
              ? []
              : self._toolbar_border_style,
            selectable: false,
            objectCaching: false,
          };
          if (self._toolbox_selected == 'tool-polyline') {
            var as =
              self._toolbar_arrow_type == 2 || self._toolbar_arrow_type == 3;
            var ae =
              self._toolbar_arrow_type == 1 || self._toolbar_arrow_type == 3;
            options.arrowStart = as;
            options.arrowEnd = ae;
            options.arrowSize = self._toolbar_arrow_size;
            options.fill = 'rgba(255,255,255,0)';
            self._making = new fabric.EgPolyline(points, options);
          } else {
            self._making = new fabric.EgPolygon(points, options);
          }
          self._canvas.add(self._making);
          self._pos = pos;
        }
        self._canvas.requestRenderAll();
        break;

      case 'tool-image':
        break;

      case 'tool-print-range':
        if (!e.target || !e.target.selectable) {
          var pos = self._canvas.getPointer(e.e);
          self._pos = pos;
          self._posSelStart = pos;
        }
        break;

      case 'tool-sector': {
        const pos = self._canvas.getPointer(e.e);
        self._pos = pos;
        // 大きさの初期値(height,width,radius)は画面上に見える程度にする
        const radius = 1;
        const centerPoint = [0, 0];
        const point1 = findSectorPointByAngle(
          centerPoint,
          [0, -radius],
          1.75 * Math.PI
        );
        const point2 = findSectorPointByAngle(
          centerPoint,
          [0, -radius],
          1.25 * Math.PI
        );
        self._making = new fabric.EgSector(
          `M -1 -1 M 1 1 M ${0} ${0} L ${point1[0]} ${point1[1]} A 1 1 0 1 1 ${
            point2[0]
          } ${point2[1]} Z`,
          {
            fill: self._toolbar_picker_background,
            stroke: self._toolbar_picker_foreground,
            strokeWidth: self._toolbar_border,
            strokeDashArray: self._toolbar_border_style,
            selectable: false,
            objectCaching: false,
            top: pos.y,
            left: pos.x,
            width: 2,
            height: 2,
          }
        );
        self._canvas.add(self._making);
        self._canvas.requestRenderAll();
        break;
      }
      case 'tool-freehand':
        freehandStart({
          pointer: self._canvas.getPointer(e.e),
          fabricCanvas: self._canvas,
        })
        break;
      default:
        break;
    }

    // console.log('debug', 'mouse:down', 'end');
  });

  self._canvas.on('mouse:move', function(e) {
    //console.log('debug', 'mouse:move', 'start', self._toolbox_selected);
    self._lastMouseMoveEvent = e.e;

    switch (self._toolbox_selected) {
      case 'tool-select':
        var pos = self._canvas.getPointer(e.e);
        self._posSelEnd = pos;
        break;
      case 'tool-pan':
      case 'tool-print-range':
        if (!self._posSelStart) {
          return;
        }
        var pos = self._canvas.getPointer(e.e);
        if (e.e.type == 'touchstart') {
          self._dragPos = pos;
        }
        if (self._dragPos == undefined) {
          self._dragPos = pos;
        }
        if (!isNaN(pos.x) && e.e.type != 'touchstart') {
          self._canvas.relativePan(
            new fabric.Point(
              (pos.x - self._dragPos.x) * self._zoom,
              (pos.y - self._dragPos.y) * self._zoom
            )
          );
        }
        self._canvas.requestRenderAll();
        break;
      case 'tool-freehand':
        freehandMove({
          pointer: self._canvas.getPointer(e.e),
          fabricCanvas: self._canvas,
        });
        break;
      default:
        break;
    }

    if (self._making == undefined) {
      return;
    }

    switch (self._toolbox_selected) {
      case 'tool-line-normal':
        var pos = self._canvas.getPointer(e.e);
        var x = pos.x;
        var y = pos.y;

        if (e.e.shiftKey) {
          var x1 = self._making.x1;
          var y1 = self._making.y1;
          if (Math.abs(x1 - x) < Math.abs(y1 - y)) {
            x = x1;
          } else {
            y = y1;
          }
        }

        self._making.set({
          x2: x,
          y2: y,
        });
        self._canvas.requestRenderAll();
        break;

      case 'tool-square':
        var pos = self._canvas.getPointer(e.e);
        var w = pos.x - self._pos.x;
        var h = pos.y - self._pos.y;
        var ws = w < 0;
        var hs = h < 0;
        var t = self._pos.y;
        var l = self._pos.x;
        if (ws) {
          l = pos.x;
          w = w * -1;
        }
        if (hs) {
          t = pos.y;
          h = h * -1;
        }
        if (e.e.shiftKey) {
          if (w > h) {
            if (ws) {
              l = self._pos.x - h;
            }
            w = h;
          } else {
            if (hs) {
              t = self._pos.y - w;
            }
            h = w;
          }
        }
        self._making.set({
          top: t,
          left: l,
          width: w,
          height: h,
        });
        self._canvas.requestRenderAll();
        break;

      case 'tool-sector': {
        if (!self._making) {
          return;
        }
        const pos = self._canvas.getPointer(e.e);
        let w = pos.x - self._pos.x;
        let h = pos.y - self._pos.y;
        const ws = w < 0;
        const hs = h < 0;
        let t = self._pos.y;
        let l = self._pos.x;
        if (ws) {
          l = pos.x;
          w = w * -1;
        }
        if (hs) {
          t = pos.y;
          h = h * -1;
        }
        if (w > h) {
          if (ws) {
            l = self._pos.x - h;
          }
          w = h;
        } else {
          if (hs) {
            t = self._pos.y - w;
          }
          h = w;
        }
        const radius = w / 2;
        const centerPoint = [0, 0];
        const point1 = findSectorPointByAngle(
          centerPoint,
          [centerPoint[0], centerPoint[1] - radius],
          1.75 * Math.PI
        );
        const point2 = findSectorPointByAngle(
          centerPoint,
          [centerPoint[0], centerPoint[1] - radius],
          1.25 * Math.PI
        );
        self._making.set({
          path: [
            ['M', -radius, -radius],
            ['M', radius, radius],
            ['M', centerPoint[0], centerPoint[1]],
            ['L', point1[0], point1[1]],
            ['A', radius, radius, 0, 1, 1, point2[0], point2[1]],
            ['Z'],
          ],
          points: [centerPoint, point1, point2],
          left: l,
          top: t,
          width: w,
          height: h,
        });
        self._canvas.requestRenderAll();
        break;
      }
      case 'tool-circle':
        var pos = self._canvas.getPointer(e.e);
        var w = pos.x - self._pos.x;
        var h = pos.y - self._pos.y;
        var ws = w < 0;
        var hs = h < 0;
        var t = self._pos.y;
        var l = self._pos.x;
        if (ws) {
          l = pos.x;
          w = w * -1;
        }
        if (hs) {
          t = pos.y;
          h = h * -1;
        }
        if (e.e.shiftKey) {
          if (w > h) {
            if (ws) {
              l = self._pos.x - h;
            }
            w = h;
          } else {
            if (hs) {
              t = self._pos.y - w;
            }
            h = w;
          }
        }
        self._making.set({
          top: t,
          left: l,
          width: w,
          height: h,
          rx: w / 2,
          ry: h / 2,
        });
        self._canvas.requestRenderAll();
        self.debug(
          `canvas mouse-move(${self._making.width},${self._making.height}).`
        );
        break;

      case 'tool-polygon':
      case 'tool-polyline':
        if (self._making) {
          var pos = self._canvas.getPointer(e.e);
          var idx = self._making.points.length - 1;
          var x = pos.x;
          var y = pos.y;
          if (e.e.shiftKey) {
            var x1 = self._making.points[idx - 1].x;
            var y1 = self._making.points[idx - 1].y;
            if (
              Math.abs(x1 - x + self._pos.x) < Math.abs(y1 - y + self._pos.y)
            ) {
              x = x1 + self._pos.x;
            } else {
              y = y1 + self._pos.y;
            }
          }
          self._making.points[idx] = {
            x: x - self._pos.x,
            y: y - self._pos.y,
          };
          self._canvas.requestRenderAll();
        }
        break;
      default:
        break;
    }

    //console.log('debug', 'mouse:move', 'end');
  });

  self._canvas.on('mouse:up', function(e) {
    // console.log('debug', 'mouse:up', 'start');

    switch (self._toolbox_selected) {
      case 'tool-point':
        if (!e || !e.target) {
          break;
        }
        var vertices = e.target;
        if (vertices.leftLine != null) {
          self._canvas.remove(vertices.leftLine);
        }
        if (vertices.rightLine != null) {
          self._canvas.remove(vertices.rightLine);
        }
        break;
      case 'tool-select':
        self._posSelStart = undefined;
        self._posSelEnd = undefined;
        self._canvas.defaultCursor = 'crosshair';
        self._canvas.hoverCursor = 'move';
        break;
      case 'tool-pan':
        self._posSelStart = undefined;
        self._posSelEnd = undefined;
        self._dragPos = undefined;
        break;
      case 'tool-sector': {
        // マウスダウンしてからマウスアップの間にsendJsonがあると_makingがなくなる
        if (!self._making) {
          break;
        }

        self._canvas.remove(self._making);

        //縦横のサイズがどちらも10未満な場合描写しない
        if (self._making.width < 10 && self._making.height < 10) {
          break;
        }

        const makingToObject = self._making.toObject();

        self._canvas.add(self._making);
        self.client.push({
          action: 'add',
          objects: [makingToObject],
        });
        self.client.flush();
        const history = self.historyInit();
        self.historyPush(self._making, history);
        self.historySet('add', history);
        self.debug(
          `object add uuid:${self._making.uuid} (${self._making.type}).`
        );
        const uuid = self._making.uuid;
        fabric.eg.setUuid(self._making, uuid);
        self._making = undefined;
        ui.toolboxSelect('tool-select');
        if (checkObjectCount(self._canvas)) {
          self._canvas.setActiveObject(fabric.eg.getFromUuid(uuid));
        }
        self._canvas.requestRenderAll();
        break;
      }
      case 'tool-line-normal':
      case 'tool-square':
      case 'tool-circle':
        // マウスダウンしてからマウスアップの間にsendJsonがあると_makingがなくなる
        if (!self._making) {
          break;
        }
        self._canvas.remove(self._making);

        //縦横のサイズがどちらも10未満な場合描写しない
        if (self._making.width < 10 && self._making.height < 10) {
          break;
        }

        var makingToObject = self._making.toObject();
        if (self._making.type === 'egLine') {
          self._making.set({
            x1: makingToObject.x1,
            x2: makingToObject.x2,
            y1: makingToObject.y1,
            y2: makingToObject.y2,
            left: makingToObject.left,
            top: makingToObject.top,
          });
        }
        self._canvas.add(self._making);
        self.client.push({
          action: 'add',
          objects: [makingToObject],
        });
        self.client.flush();
        var history = self.historyInit();
        self.historyPush(self._making, history);
        self.historySet('add', history);
        self.debug(
          `object add uuid:${self._making.uuid} (${self._making.type}).`
        );
        const uuid = self._making.uuid;
        fabric.eg.setUuid(self._making, uuid);
        self._making = undefined;
        ui.toolboxSelect('tool-select');
        if (checkObjectCount(self._canvas)) {
          self._canvas.setActiveObject(fabric.eg.getFromUuid(uuid));
        }
        self._canvas.requestRenderAll();
        break;

      case 'tool-polyline':
      case 'tool-polygon':
        if (e.e.which === 3) {
          break;
        }

        var pos = self._canvas.getPointer(e.e);

        if (self._making) {
          var fp = self._making.points[0];
          var x = pos.x - self._pos.x;
          var y = pos.y - self._pos.y;
          // 最初の頂点から変化していない場合は不要な頂点を作成することになるので何もしない
          if (
            self._making.points.length === 2 &&
            Math.abs(x - fp.x) < 1 &&
            Math.abs(y - fp.y) < 1
          ) {
            break;
          }

          if (
            self._toolbox_selected === 'tool-polygon' &&
            self._making.points.length > 2 &&
            Math.abs(x - fp.x) < 5 &&
            Math.abs(y - fp.y) < 5
          ) {
            self.addPoly();
          } else {
            self._making.points.push({
              x: pos.x - self._pos.x,
              y: pos.y - self._pos.y,
            });
          }
        }
        self._canvas.requestRenderAll();
        break;

      case 'tool-font':
        self._pos = self._canvas.getPointer(e.e);
        self._making = undefined;
        var itext = fabric.EgText.fromObject({
          text: '',
          top: self._pos.y,
          left: self._pos.x,
          fontFamily: "'Hiragino Kaku Gothic ProN', Meiryo, sans-serif",
          fontSize: self._toolbar_font_size * 1.5,
          fill: self._toolbar_picker_text,
          textBackgroundColor: self._toolbar_picker_background,
        });
        self._canvas.add(itext);
        self.client.push({
          action: 'add',
          objects: [itext.toObject()],
        });
        self.client.flush();
        const history = self.historyInit();
        self.historyPush(itext, history);
        self.historySet('add', history);
        ui.toolboxSelect('tool-select');
        self._canvas.setActiveObject(itext);
        itext.enterEditing();
        break;

      case 'tool-parts':
        console.log('poinet', self._parts_url);
        self._pos = self._canvas.getPointer(e.e);
        if (self._parts_url) {
          self.addImage(encodeURI(self._parts_url), true);
        }
        break;

      case 'tool-zoom-up':
        var x = e.e.layerX;
        var y = e.e.layerY;
        var zoom = self._canvas.getZoom();
        if (zoom < 1) {
          zoom = zoom + 0.25;
        } else if (zoom < 2) {
          zoom = zoom + 0.5;
        } else {
          zoom = zoom + 1.0;
        }
        if (zoom > 8.0) {
          zoom = 8.0;
        }
        self.setZoom(zoom, x, y);
        break;

      case 'tool-zoom-down':
        var x = e.e.layerX;
        var y = e.e.layerY;
        var zoom = self._canvas.getZoom();
        if (zoom <= 1) {
          zoom = zoom - 0.25;
        } else if (zoom <= 2) {
          zoom = zoom - 0.5;
        } else {
          zoom = zoom - 1.0;
        }
        if (zoom < 0.25) {
          zoom = 0.25;
        }
        zoom = parseInt(zoom * 20) / 20;
        self.setZoom(zoom, x, y);
        break;
      case 'tool-print-range':
        self._posSelStart = undefined;
        self._posSelEnd = undefined;
        self._dragPos = undefined;
        var printFrame = self.findPrintFrame(self._canvas.getObjects());
        if (printFrame) {
          printFrame.resizeToScale();
          printFrame.setCoords();
        }
        self._canvas.requestRenderAll();
        break;
      case 'tool-freehand':
        freehandEnd();
        drawing.setToolbarItem();
        break;
      default:
        break;
    }
    self._gesture = false;
    // console.log('debug', 'mouse:up', 'end');
  });

  $(self._canvas.wrapperEl).on('wheel', function(e) {
    //console.log('debug', 'mouse:wheel', 'start');

    var delta = e.originalEvent.deltaY
      ? -e.originalEvent.deltaY
      : e.originalEvent.wheelDelta
      ? e.originalEvent.wheelDelta
      : -e.originalEvent.detail;
    delta = delta / 1000;

    if (e.originalEvent.shiftKey) {
      var pos = self._canvas.getPointer(e.originalEvent);
      var x = pos.x;
      var y = pos.y;
      var zoom = self._canvas.getZoom();

      zoom = zoom + delta;

      self.setZoom(zoom, x, y);
      e.originalEvent.preventDefault();
    }

    //console.log('debug', 'mouse:wheel', 'end');
  });

  self._canvas.on('touch:gesture', function(e) {
    console.log('debug', 'touch:gesture', 'start');

    switch (self._toolbox_selected) {
      case 'tool-pan':
      case 'tool-zoom-up':
      case 'tool-zoom-down':
        var lPinchScale = e.self.scale;
        var type = e.e.type;
        if (type == 'touchstart') {
          console.log('debug', 'touchstart');
          self._startZoom = self._canvas.getZoom();
          self._save_toolbox_selected = self._toolbox_selected;
          self._dragPos = new fabric.Point(e.e.layerX, e.e.layerY);
        } else if (type == 'touchmove') {
          var pos = new fabric.Point(e.e.layerX, e.e.layerY);
          var x = (pos.x + self._dragPos.x) / 2;
          var y = (pos.y + self._dragPos.y) / 2;
          var zoom = self._startZoom * lPinchScale;
          if (zoom > 8.0) {
            zoom = 8.0;
          }
          if (zoom < 0.25) {
            zoom = 0.25;
          }

          if (Math.abs(zoom - self._startZoom) > 0.1) {
            zoom = parseInt(zoom * 10) / 10;
            self.setZoom(zoom, x, y);
          } else {
            if (self._toolbox_selected == 'tool-pan') {
              if (!isNaN(pos.x) && self._canvas.getZoom() >= 1.0) {
                self._canvas.relativePan(
                  new fabric.Point(
                    pos.x - self._dragPos.x,
                    pos.y - self._dragPos.y
                  )
                );
              }
            }
          }

          console.log('debug', `touchmove:${lPinchScale}, ${zoom}`);
        } else if (type == 'touchend') {
          console.log('debug', 'touchend');
          self.toolboxSelect(self._save_toolbox_selected);
        } else {
          console.log('debug', `gesture that is not move or start:${type}`);
        }
        self._canvas.requestRenderAll();
        break;
      default:
        break;
    }
    self._gesture = true;

    console.log('debug', 'touch:gesture', 'end');
  });

  self._canvas.on('touch:drag', function(e) {
    console.log('debug', 'touch:drag', 'start');
    if (e.e.type == undefined) {
      return;
    }
    if (self._gesture) {
      return;
    }
    switch (self._toolbox_selected) {
      // case 'tool-pan':
      //   var pos = self._canvas.getPointer(e.e);
      //   if (e.e.type == 'touchstart') self._dragPos = pos;
      //   if (self._dragPos == undefined) self._dragPos = pos;
      //   self.debug("canvas dragging." + pos.x + "," + pos.y + "," + self._dragPos.x + "," + self._dragPos.y + "," + self._gesture);
      //   if ((!isNaN(pos.x)) && (e.e.type != 'touchstart')) {
      //     self._canvas.relativePan(new fabric.Point((pos.x - self._dragPos.x) * self._zoom, (pos.y - self._dragPos.y) * self._zoom));
      //   }
      //   break;
      case 'tool-zoom-up':
      case 'tool-zoom-down':
        // eslint-disable-next-line no-unused-vars
        var pos = self._canvas.getPointer(e.e);
        if (e.e.type == 'touchmove') {
          ui.toolboxSelect('tool-pan');
        }
        break;
      default:
        break;
    }
    self._gesture = false;

    console.log('debug', 'touch:drag', 'end');
  });

  self._canvas.on('object:scaling', function(e) {
    const { isSelectMulti, isSelectOneGroup } = self.getSelectionStatus(
      self._target
    );
    if (isSelectMulti || isSelectOneGroup) {
      const group = e.target;
      const handleGroupScaling = groupObj => {
        groupObj.getObjects().forEach(childObj => {
          if (childObj._objects) {
            handleGroupScaling(childObj);
          } else if (childObj.type === 'egSector') {
            if (group.scaleY < group.scaleX) {
              childObj.scaleX = group.scaleY / group.scaleX;
            } else {
              childObj.scaleY = group.scaleX / group.scaleY;
            }
            childObj.setCoords();
          }
        });
      };
      handleGroupScaling(group);
    }
  });

  // 画面リサイズしたらdevicePixelRatioを変更
  window.addEventListener('resize', () => {
    fabric.devicePixelRatio = window.devicePixelRatio;
    self._canvas.renderAll();
  });

  // canvasサイズを.layoutに合わせる
  const resizeObserver = new window.ResizeObserver(entries => {
    entries.forEach(e => {
      self._canvas.setDimensions({
        width: e.contentRect.width,
        height: e.contentRect.height,
      });
      self._canvas.renderAll();
    });
  });
  resizeObserver.observe(document.querySelector('.layout'));

  return self._canvas;
};

// 画面の更新
_drawing.prototype.updateScreen = function() {
  var self = this;
  self.setSelection();
  self.setToolbarItem();
};

// キャンパスを取得
_drawing.prototype.getCanvas = function() {
  return this._canvas;
};

// オブジェクト数表示
_drawing.prototype.updateObjectCount = function() {
  $('.object_max_count').html(`/${this._object_max_count}`);
  var objCount = this.getObjectCount(this._canvas.getObjects());
  $('.object_count').html(objCount);
  $('.object_count').removeClass('_error');
  if (objCount >= this._object_max_count) {
    $('.object_count').addClass('_error');
  }
};

// オブジェクト数限界までの残りカウント
_drawing.prototype.getObjectRemainingCount = function() {
  var objCount = this.getObjectCount(this._canvas.getObjects());
  return this._object_max_count - objCount;
};

// 選択しているオブジェクトの数取得
_drawing.prototype.getTargetObjectCount = function() {
  return this.getObjectCount(this._target._objects);
};

// オブジェクト数取得
_drawing.prototype.getObjectCount = function(obj) {
  var count = 0;
  _.each(obj, function(item) {
    if (item.createrId == 0) {
      // 初期データはカウントしない
      return true;
    }
    if (item.type == 'path') {
      // 自由線作成時に複製されたオブジェクトはカウントしない
      return true;
    }
    if (item.type == 'egGroup') {
      // グループ化されている場合は子オブジェクトの数を加算する
      count = count + drawing.getObjectCount(item._objects);
    } else {
      count++;
    }
  });
  return count;
};

// 現在の選択状態を取得
_drawing.prototype.getSelectionStatus = function(target) {
  const self = this;
  // this.debug('getSelectionStatus', target);

  const isSelect = Boolean(target);

  const isSelectOne = isSelect && target.uuid ? true : false;

  const isSelectOneLock = isSelectOne && target.locked ? true : false;
  // 選択したオブジェクト単体がロックされているかどうか判定

  const isSelectOneGroup = isSelectOne && target._objects && target.type !== "customFreehand" ? true : false;

  const isSelectOneGroupIncludeLock =
    isSelectOneGroup && self._includeLockSubObjects(target);

  const isSelectMulti =
    isSelect && !target.uuid && target._objects ? true : false;
  const isSelectMultiIncludeGroup =
    isSelectMulti && _.some(target._objects, obj => obj._objects && obj.type !== 'customFreehand');
  // オブジェクト複数選択した内部に、グループ化オブジェクトが含まれているかどうかを判定

  const isSelectMultiAnyLock = isSelectMulti
    ? self._includeLockSubObjects(target)
    : false;

  const isSelectMultiAllLock = isSelectMulti
    ? _.every(target._objects, obj => obj.locked !== 0)
    : false;

  const isLock = (() => {
    if (isSelectOne) {
      return isSelectOneLock || isSelectOneGroupIncludeLock;
    } else if (isSelectMulti) {
      return isSelectMultiAnyLock;
    } else {
      return false;
    }
  })();

  const canUnlock = (() => {
    if (isSelectOne) {
      // 単独選択時

      // グループ化オブジェクトで下位にロックオブジェクトがある場合
      if (isSelectOneGroupIncludeLock) {
        // BLDE_10514対応
        return true;
      }

      // ロックされていなければロック解除できない
      if (!isSelectOneLock) {
        return false;
      }

      // もし現在の権限が元請ではない場合(協力会社の場合)
      // 選択オブジェクトに[現場監督ロック]がかかっている場合、
      // ロック解除できないようにする
      if (isLoginUserPartnerCompany()) {
        if (target.lockManager >= 0) {
          return false;
        }
      }

      return true;
    } else if (isSelectMulti) {
      // 複数選択時

      // すべてのオブジェクトがロックしていないと解除はできない
      if (!isSelectMultiAllLock) {
        return false;
      }

      // もし現在の権限が元請ではない場合(協力会社の場合)
      // 複数選択オブジェクトのどれかに[現場監督ロック]がかかっている場合、
      // ロック解除できないようにする。
      if (isLoginUserPartnerCompany()) {
        if (_.some(target._objects, object => object.lockManager >= 0)) {
          return false;
        }
      }

      // ロックされているものの中で、
      // どれかがグループ化オブジェクトの場合
      if (isSelectMultiIncludeGroup) {
        // BLDE_10514対応
        return true;
      }

      return true;
    }
    return false;
  })();

  const canLock = (() => {
    if (isSelectOne) {
      // 単独選択時

      // もし現在の権限が元請ではない場合(協力会社の場合)
      // 選択オブジェクトに[現場監督ロック]がかかっている場合、
      // [職長ロック]に変更できないようにする
      if (isLoginUserPartnerCompany()) {
        if (target.lockManager >= 0) {
          return false;
        }
      }

      // ロックされていなければロック可能
      if (!isSelectOneLock) {
        return true;
      }

      return false;
    } else if (isSelectMulti) {
      // 複数選択時

      // もし現在の権限が元請ではない場合(協力会社の場合)
      // 複数選択オブジェクトのどれかに[現場監督ロック]がかかっている場合、
      // [職長ロック]に変更できないようにする
      if (isLoginUserPartnerCompany()) {
        if (_.some(target._objects, object => object.lockManager >= 0)) {
          return false;
        }
      }

      // すべてのオブジェクトがロックされているわけではない場合
      // ロック可能
      if (!isSelectMultiAllLock) {
        return true;
      }

      return false;
    }
    return false;
  })();

  const canUndo = (() => {
    if (drawing._toolbox_selected === 'tool-freehand') {
      return canUndoPen();
    } else {
      return historyFilo.isPrev();
    }
  })();

  const canRedo = (() => {
    if (drawing._toolbox_selected === 'tool-freehand') {
      return canRedoPen();
    } else {
      return historyFilo.isNext();
    }
  })();

  return {
    canUndo,
    canRedo,

    isSelect,
    isSelectOne,
    isSelectOneLock,
    isSelectOneGroup,
    isSelectOneGroupIncludeLock,
    isSelectMulti,
    isSelectMultiIncludeGroup,
    isSelectMultiAnyLock,
    isSelectMultiAllLock,
    isLock,
    canLock,
    canUnlock,
  };
};

// 下位オブジェクトにロックしたものが含まれているかどうかを確認する
_drawing.prototype._includeLockSubObjects = object => {
  // 再帰を利用して下位オブジェクトにロックしているものがあるかどうかを判定する
  const includeLockChildObjects = target => {
    if (!Array.isArray(target._objects)) {
      return false;
    }
    for (let i = 0; i <= target._objects.length - 1; i += 1) {
      const obj = target._objects[i];
      if (obj.locked && obj.locked !== 0) {
        return true;
      }
      if (obj._objects) {
        if (includeLockChildObjects(obj)) {
          return true;
        }
      }
    }
    return false;
  };
  return includeLockChildObjects(object);
};

// オブジェクトに Fabric.js でのマウス操作ロックをかける
_drawing.prototype._objectLockMouseControl = (object, lock = true) => {
  object.set({
    lockMovementY: lock,
    lockMovementX: lock,
    lockScalingY: lock,
    lockScalingX: lock,
    lockRotation: lock,
  });
};

// Selectableの状態変更
_drawing.prototype.canvasAllObjectsSelectableChange = function(selectable) {
  this._canvas.forEachObject(function(o) {
    if (!o.neverSelectable) {
      o.selectable = selectable;
    }
  });
};

// 選択状態の表示設定
_drawing.prototype.setSelection = function() {
  var self = this;
  // console.log('debug', 'setSelection', self._target);

  /* eslint-disable no-unused-vars */
  var utype = userinfo.getUserType();
  var col = '#666';
  /* eslint-enable no-unused-vars */

  // 情報ダイアログの表示
  var disp = {
    updaterCompany: '-',
    updater: '-',
    updated: '-',
    createrCompany: '-',
    creater: '-',
    created: '-',
    lock: 'ロック状態 -',
    lockerCompany: '-',
    lockerName: '-',
    lockedDateTime: '-',
  };

  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );

  // console.log('debug', 'setSelection', isSelect, isSelectMulti);

  if (isSelect) {
    // ロック状態をみて Fabric.js のマウスロックをかける
    self._objectLockMouseControl(self._target, isLock);

    // ロックフラグ
    let isLockManager = false; // 現場監督
    let isLockForeman = false; // 職長

    if (isSelectMulti) {
      // 複数選択
      _.each(self._target._objects, function(object) {
        if (object.lockManager >= 0) {
          isLockManager = true;
          object.set(self.managerLockedProperty);
        } else if (object.lockForeman >= 0) {
          isLockForeman = true;
          object.set(self.foremanLockedProperty);
        } else {
          object.set(self.unLockedProperty);
        }
      });
    } else {
      // 単独選択
      disp.updaterCompany = self._target.updaterCompanyName;
      disp.updater = self._target.updaterName;
      disp.updated = util.dataFormat(
        new Date(self._target.updated),
        'YYYY/MM/DD hh:mm:ss'
      );
      disp.createrCompany = self._target.createrCompanyName;
      disp.creater = self._target.createrName;
      disp.created = util.dataFormat(
        new Date(self._target.created),
        'YYYY/MM/DD hh:mm:ss'
      );

      isLockManager = self._target.lockManager >= 0;
      isLockForeman = self._target.lockForeman >= 0;
      if (isLockManager || isLockForeman) {
        disp.lockerCompany = self._target.lockerCompanyName;
        disp.lockerName = self._target.lockerName;
        disp.lockedDateTime = util.dataFormat(
          new Date(self._target.locked),
          'YYYY/MM/DD hh:mm:ss'
        );
      }
    }

    // 現場監督ロックを優先的に表示する
    if (isLockManager) {
      disp.lock = 'ロック状態 現場監督ロック';
      self._target.set(self.managerLockedProperty);
    } else if (isLockForeman) {
      disp.lock = 'ロック状態 職長ロック';
      self._target.set(self.foremanLockedProperty);
    } else {
      self._target.set(self.unLockedProperty);
    }

    if (util.getDevice() == 'other') {
      self._target.set({
        rotatingPointOffset: 40,
        cornerSize: 12,
      });
    } else {
      self._target.set({
        rotatingPointOffset: 80,
        cornerSize: 24,
      });
    }
    self._canvas.requestRenderAll();
  }

  $('#dlg-info-creater-company').text(disp.createrCompany);
  $('#dlg-info-creater').text(disp.creater);
  $('#dlg-info-created').text(disp.created);
  $('#dlg-info-updater-company').text(disp.updaterCompany);
  $('#dlg-info-updater').text(disp.updater);
  $('#dlg-info-updated').text(disp.updated);
  $('#dlg-info-lock').text(disp.lock);
  $('#dlg-info-locker-company').text(disp.lockerCompany);
  $('#dlg-info-locker').text(disp.lockerName);
  $('#dlg-info-locked').text(disp.lockedDateTime);
};

// ツールボックス内の項目を選択
_drawing.prototype.toolboxSelect = function(modeName, stopPolyCreation = true) {
  var self = this;
  var prev_toolbox_selected = self._toolbox_selected

  if (!modeName) {
    modeName = self._toolbox_selected;
    // throw new Error('toolboxSelect modeName = false!');
  }

  // ポリゴン描画中なら終了させる
  if (
    stopPolyCreation === true &&
    ['tool-polyline', 'tool-polygon'].includes(self._toolbox_selected) &&
    _.isObject(self._making)
  ) {
    self.addPoly();
  }

  // 選択値を保存
  self._toolbox_selected = modeName;

  // 作成中オブジェクトをクリア
  self._making = undefined;
  self._target = undefined;

  // 選択値に応じた初期設定
  if (self._canvas) {
    if (self._toolbox_selected !== 'tool-freehand') {
      penEnd({
        fabricCanvas: self._canvas,
      })
    }
    self._canvas.discardActiveObject();
    self._canvas.fire('selection:cleared', {});
    const selectable = modeName === 'tool-select';
    self._canvas.selection = selectable;
    self.canvasAllObjectsSelectableChange(selectable);

    switch (self._toolbox_selected) {
      case 'tool-pan':
        self._canvas.defaultCursor = 'all-scroll';
        self._canvas.hoverCursor = 'all-scroll';
        break;
      case 'tool-pointer':
        self._canvas.defaultCursor = `${self.cursor.pointer}, default`;
        self._canvas.hoverCursor = `${self.cursor.pointer}, move`;
        break;
      case 'tool-arrow-pointer':
        self._canvas.defaultCursor = `${self.cursor.arrow}, default`;
        self._canvas.hoverCursor = `${self.cursor.arrow}, move`;
        break;
      case 'tool-zoom-up':
      case 'tool-zoom-down':
        self._canvas.defaultCursor = 'default';
        self._canvas.hoverCursor = 'move';
        break;
      case 'tool-font':
        self._canvas.defaultCursor = 'crosshair';
        self._canvas.hoverCursor = 'crosshair';
        break;
      case 'tool-image':
        const isUploading = (() => {
          const events = $._data(window, 'events');
          if (_.isEmpty(events)) {
            return false;
          }
          const focusEvents = events.focus;
          if (_.isNil(focusEvents)) {
            return false;
          }
          return focusEvents.some(e => e.namespace === 'image-upload');
        })();
        if (!isUploading) {
          $('#image-upload').trigger('click');
        }
        break;
      case 'tool-freehand':
        if (prev_toolbox_selected === 'tool-freehand') {
          finalizeStroke({
            fabricCanvas: self._canvas,
          })
        } else {
          penStart({
            fabricCanvas: self._canvas,
          })
        }
        break;
      default:
        self._canvas.defaultCursor = 'crosshair';
        self._canvas.hoverCursor = 'move';
        break;
    }
    self._canvas.requestRenderAll();
  }
  self.debug(`${modeName} select.`);
};

// ツールバーの選択値・利用可否を設定
_drawing.prototype.setToolbarItem = function() {
  var self = this;

  const {
    isSelect,
    isSelectOne,
    isSelectMulti,
    isSelectOneGroup,
    isSelectMultiAnyLock,
    isSelectMultiIncludeGroup,
    isLock,
    canUnlock,
    canLock,
    canUndo,
    canRedo,
  } = self.getSelectionStatus(self._target);
  const canPaste = Boolean(self._clip);

  if (isSelectOne) {
    // 選択が単数の場合、選択中の値を設定
    ui.setBorderWidth(self._target.strokeWidth);
    var st = self._target.strokeDashArray;
    if (Array.isArray(st)) {
      if (st[0] == 1) {
        st = 1;
      } else if (st[0] == 5) {
        st = 2;
      } else {
        st = _.isEmpty(st) ? 1 : 3;
      }
    } else {
      st = 1;
    }

    ui.setBorderStyle(st);
    if (self._target.type === 'customFreehand') {
      ui.setForegroundColor(self._target._objects[0].fill);
      ui.setBorderWidth(self._target.strokeSize);
    } else if (self._target.stroke == null) {
      ui.setForegroundColor(self._toolbar_picker_foreground);
    } else {
      ui.setForegroundColor(self._target.stroke);
    }
    if (self._target.type == 'egText') {
      ui.setTextColor(self._target.fill);
      if (self._target.get('textBackgroundColor') == null) {
        ui.setBackgroundColor(self._toolbar_picker_background);
      } else {
        ui.setBackgroundColor(self._target.get('textBackgroundColor'));
      }
    } else {
      ui.setTextColor(self._toolbar_picker_text);
      if (self._target.fill == null) {
        ui.setBackgroundColor(self._toolbar_picker_background);
      } else {
        ui.setBackgroundColor(self._target.fill);
      }
    }
    var asz, atp;
    if (self._target.arrowSize) {
      asz = self._target.arrowSize;
      atp = 0;
      if (self._target.arrowEnd) {
        atp = 1;
      }
      if (self._target.arrowStart) {
        atp = 2;
      }
      if (self._target.arrowStart && self._target.arrowEnd) {
        atp = 3;
      }
    } else {
      asz = self._toolbar_arrow_size;
      atp = self._toolbar_arrow_type;
    }
    ui.setArrowSize(asz);
    ui.setArrowType(atp);
    if (self._target.fontSize == null) {
      ui.setFontSize(self._toolbar_font_size * 1.5);
    } else {
      ui.setFontSize(self._target.fontSize);
    }
    ui.setToolbarButtonEnable('toolbar-group', false);
  } else {
    // 選択が複数もしくは未選択の場合、デフォルト値を設定
    ui.setBorderWidth(self._toolbar_border);
    var st = self._toolbar_border_style;
    if (st[0] == 1) {
      st = 1;
    } else if (st[0] == 5) {
      st = 2;
    } else {
      st = 3;
    }
    ui.setBorderStyle(st);
    ui.setForegroundColor(self._toolbar_picker_foreground);
    ui.setBackgroundColor(self._toolbar_picker_background);
    ui.setTextColor(self._toolbar_picker_text);
    ui.setArrowSize(self._toolbar_arrow_size);
    ui.setArrowType(self._toolbar_arrow_type);
    ui.setFontSize(self._toolbar_font_size * 1.5);
  }

  if (isSelectMulti && !isSelectMultiIncludeGroup) {
    const objects = self._target._objects;
    const decoratorMapping = [
      {
        condition: x => x.fontSize,
        value: x => x.fontSize,
        set: x => ui.setFontSize(x),
      },
      {
        condition: x => (x.stroke && x.strokeWidth) || x.strokeSize,
        value: x => {
          if (x.strokeSize) {
            return x.strokeSize;
          }
          return x.strokeWidth;
        },
        set: x => ui.setBorderWidth(x),
      },
      {
        condition: x => x.arrowSize,
        value: x => {
          atp = 0;
          if (x.arrowEnd) {
            atp = 1;
          }
          if (x.arrowStart) {
            atp = 2;
          }
          if (x.arrowStart && x.arrowEnd) {
            atp = 3;
          }
          return atp;
        },
        set: x => ui.setArrowType(x),
      },
    ];

    decoratorMapping.forEach(decorator => {
      const groupValues = _.uniq(
        _.reduce(
          objects,
          (accum, item) => {
            if (decorator.condition(item)) {
              accum.push(decorator.value(item));
            }
            return accum;
          },
          []
        )
      );

      if (groupValues.length === 1) {
        decorator.set(groupValues[0]);
      }
    });
  }

  ui.setStatusToolbarObjectEditTab(isSelect);

  // // 設定不可な項目は選択不可とする
  ui.setToolbarButtonEnable('toolbar-delete', isSelect && !isLock);
  ui.setToolbarButtonEnable('toolbar-duplicate', isSelect && !isLock);
  ui.setToolbarButtonEnable('toolbar-move-front', isSelect && !isLock);
  ui.setToolbarButtonEnable('toolbar-move-back', isSelect && !isLock);
  // 2019.08.06 ロックオブジェクトを含んでのグループ化はできない
  ui.setToolbarButtonEnable(
    'toolbar-group',
    isSelectMulti && !isSelectMultiAnyLock
  );
  ui.setToolbarButtonEnable('toolbar-ungroup', isSelectOneGroup && !isLock);
  if (isSelectOneGroup) {
    ui.setToolbarButtonShowHide('toolbar-ungroup', 'toolbar-group');
    $('.toolbar-ungroup')
      .closest('.layout-tool__item')
      .removeClass('pointer-events-none');

    $('.label-group span').html('グループ解除');
  } else {
    ui.setToolbarButtonShowHide('toolbar-group', 'toolbar-ungroup');
    $('.toolbar-group')
      .closest('.layout-tool__item')
      .removeClass('pointer-events-none');

    $('.label-group span').html('グループ化');
  }

  // Check disable tool group
  const numberOfSelectedObject = self._canvas.getActiveObjects().length;
  if (
    (numberOfSelectedObject === 1 && !isSelectOneGroup) ||
    (isSelectMulti && isSelectMultiAnyLock)
  ) {
    $('.toolbar-group')
      .closest('.layout-tool__item')
      .addClass('pointer-events-none');
  } else {
    $('.toolbar-group')
      .closest('.layout-tool__item')
      .removeClass('pointer-events-none');
  }

  ui.setToolbarButtonEnable('toolbar-copy', isSelect);
  ui.setToolbarButtonEnable('toolbar-cut', isSelect && !isLock);
  ui.setToolbarButtonEnable('toolbar-paste', canPaste);
  ui.setToolbarButtonEnable('toolbar-undo', canUndo);
  ui.setToolbarButtonEnable('toolbar-redo', canRedo);
  ui.setToolbarButtonEnable('toolbar-lock', canLock);
  ui.setToolbarButtonEnable('toolbar-unlock', canUnlock);
  if (canUnlock) {
    ui.setToolbarButtonShowHide('toolbar-unlock', 'toolbar-lock');
    $('.toolbar-unlock')
      .closest('.layout-tool__item')
      .removeClass('pointer-events-none');

    $('.label-lock span').html('ロック解除');
  } else {
    ui.setToolbarButtonShowHide('toolbar-lock', 'toolbar-unlock');
    $('.toolbar-lock')
      .closest('.layout-tool__item')
      .removeClass('pointer-events-none');

    $('.label-lock span').html('ロック');
  }
  ui.setToolbarButtonEnable('toolbar-info', true);
  let statuses = self.getSelectionStatus(self._target);
  if (isSelectOneGroup) {
    ui.styleWithGroupLocked(statuses);
  }
  ui.checkDisableMoveFrontOrBack(self._canvas, self._canvas.getActiveObject());
  ui.disableToolWithPrint(self.findPrintFrame(self._canvas.getObjects()));
  ui.styleWithTargetLocked(statuses, self._target);
};

// 線種を設定
_drawing.prototype.setBorderStyle = function(s) {
  var self = this;
  let isRectOrPolygon =
    self._target &&
    ('egRect' === self._target.type || 'egPolygon' === self._target.type);
  if (parseInt(s) == 1) {
    // When zoom up or change border size, the object is missing strokes
    if (isRectOrPolygon) {
      s = [];
    } else {
      s = [1, 0];
    }
  } else if (parseInt(s) == 2) {
    s = [5, 5];
  } else {
    s = [10, 5, 3, 5];
  }

  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );

  if (isSelect) {
    if (isLock) {
      return;
    }
    var history = self.historyInit();
    if (isSelectMulti) {
      _.each(self._target._objects, function(object) {
        if (!isEnableToolStyle('BORDER', object.type)) {
          return; // continue next object
        }
        if (object.strokeDashArray) {
          object.strokeDashArray = s;
          object.dirty = true;
          self.client.push({
            action: 'attribute',
            uuid: object.uuid,
            strokeDashArray: s,
          });
          const objectProperties = self.getObjectPropertiesInGroup(
            self._target,
            object
          );
          self.historyPush(object, history, {
            ...objectProperties,
          });
        }
      });
      self._canvas.requestRenderAll();
      console.log('debug', `set target(s) border style (${s}).`);
    } else {
      self._target.strokeDashArray = s;
      self._target.dirty = true;
      self.client.push({
        action: 'attribute',
        uuid: self._target.uuid,
        strokeDashArray: s,
      });
      self.historyPush(self._target, history, {});
      self._canvas.requestRenderAll();
      console.log('debug', `set target border style (${s}).`);
    }
    self.client.flush();
    self.historySet('modify', history);
  }
};

// 線の太さを設定
_drawing.prototype.setBorderWidth = function(w) {
  var self = this;
  if ($.isNumeric(w)) {
    w = parseFloat(w);
  } else {
    w = 1;
  }

  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );
  if (isSelect) {
    if (isLock) {
      return;
    }
    var history = self.historyInit();
    if (isSelectMulti) {
      _.each(self._target._objects, function(object) {
        if (!isEnableToolStyle('BORDER', object.type) && object.type !== 'customFreehand') {
          return; // continue next object
        }
        if (object.type === 'customFreehand') {
          updateFreehandGroupThickness(object, w);
          const objectProperties = self.getObjectPropertiesInGroup(
            self._target,
            object
          );
          self.historyPush(object, history, { ...objectProperties });
        } else if (object.strokeWidth && object.type !== 'egText') {
          object.strokeWidth = w;
          object.dirty = true;
          self.client.push({
            action: 'attribute',
            uuid: object.uuid,
            strokeWidth: w,
          });
          const objectProperties = self.getObjectPropertiesInGroup(
            self._target,
            object
          );
          self.historyPush(object, history, {
            ...objectProperties,
          });
        }
      });
      self._canvas.requestRenderAll();
      console.log('debug', `set target(s) border width (${w}).`);
    } else if (self._target.type === 'customFreehand') {
      updateFreehandGroupThickness(self._target, w);
      self.historyPush(self._target, history, {});
      self._canvas.requestRenderAll();
    } else {
      if (self._target.strokeWidth && self._target.type !== 'egText') {
        self._target.strokeWidth = w;
        self._target.dirty = true;
        self.client.push({
          action: 'attribute',
          uuid: self._target.uuid,
          strokeWidth: w,
        });
        self.historyPush(self._target, history, {});
        self._canvas.requestRenderAll();

        console.log('debug', `set target border width (${w}).`);
      }
    }
    self.client.flush();
    self.historySet('modify', history);
  }
};

// 線の色を設定
_drawing.prototype.setForegroundColor = function(c) {
  var self = this;
  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );
  if (isSelect) {
    if (isLock) {
      return;
    }
    var history = self.historyInit();
    if (isSelectMulti) {
      _.each(self._target._objects, function(object) {
        if (!isEnableToolStyle('BORDER', object.type) && object.type !== 'customFreehand') {
          return; // continue next object
        }
        if (c === 'rgba(255,255,255, 0)' && !drawing._shapes.includes(object.type)) {
          return;
        }
        if (object.type === 'customFreehand') {
          updateCustomFreehandColor(object, c);
          const objectProperties = self.getObjectPropertiesInGroup(
            self._target,
            object
          );
          self.historyPush(object, history, { ...objectProperties });
        } else if (object.stroke && object.type !== 'egText') {
          object.stroke = c;
          object.dirty = true;
          self.client.push({
            action: 'attribute',
            uuid: object.uuid,
            stroke: c,
          });
          const objectProperties = self.getObjectPropertiesInGroup(
            self._target,
            object
          );
          self.historyPush(object, history, {
            ...objectProperties,
          });
        }
      });

      self._canvas.requestRenderAll();
      console.log('debug', `set target(s) foreground color (${c}).`);
    } else if (self._target.type === 'customFreehand') {
      updateCustomFreehandColor(self._target, c);
      self.historyPush(self._target, history, {});
      self._canvas.requestRenderAll();
    } else {
      if (self._target.stroke && self._target.type !== 'egText') {
        self._target.stroke = c;
        self._target.dirty = true;
        self._canvas.requestRenderAll();
        self.client.push({
          action: 'attribute',
          uuid: self._target.uuid,
          stroke: c,
        });
        self.historyPush(self._target, history, {});
        console.log('debug', `set target foreground color (${c}).`);
      }
    }
    self.client.flush();
    self.historySet('modify', history);
  }
};

// 矢印の種類を設定
_drawing.prototype.setArrowType = function(t) {
  var self = this;
  let list = {
    0: 'i-tool-arrow-type-1',
    1: 'i-tool-arrow-type-2',
    2: 'i-tool-arrow-type-3',
    3: 'i-tool-arrow-type-4',
  };

  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );
  if (isSelect) {
    if (isLock) {
      return;
    }
    var history = self.historyInit();
    var s = false,
      e = false;
    switch (t) {
      case '1':
        e = true;
        break;
      case '2':
        s = true;
        break;
      case '3':
        s = true;
        e = true;
        break;
      default:
        break;
    }
    if (isSelectMulti) {
      _.each(self._target._objects, function(object) {
        if (!isEnableToolStyle('ARROW', object.type)) {
          return; // continue next object
        }
        object.arrowStart = s;
        object.arrowEnd = e;
        object.objectCaching = false;
        object.dirty = true;
        self.client.push({
          action: 'attribute',
          uuid: object.uuid,
          arrowStart: s,
          arrowEnd: e,
        });
        const objectProperties = self.getObjectPropertiesInGroup(
          self._target,
          object
        );
        self.historyPush(object, history, {
          ...objectProperties,
        });
      });
      self._canvas.requestRenderAll();
      $('.tool-arrow-type__value input').val(t);
      _.each(list, function(class_name) {
        $('#dropdown-border-arrow .selected-icon').removeClass(class_name);
      });
      $('#dropdown-border-arrow .selected-icon').addClass(list[t]);
      console.log('debug', `set target(s) arrow type (${t}).`);
    } else {
      if (self._target.arrowStart !== undefined) {
        self._target.arrowStart = s;
        self._target.arrowEnd = e;
        self._target.objectCaching = false;
        self._target.dirty = true;
        self.client.push({
          action: 'attribute',
          uuid: self._target.uuid,
          arrowStart: s,
          arrowEnd: e,
        });
        self.historyPush(self._target, history, {});
        self._canvas.requestRenderAll();
        console.log('debug', `set target arrow type (${t}).`);
      }
    }
    const arrowTypeSelectedContent = $(`button.${list[t]}`).html();
    $('.tool-arrow-type__input-text').html(arrowTypeSelectedContent);
    self.client.flush();
    self.historySet('modify', history);
    ui.checkDisableToolLineSize();
  }
};

// 矢印のサイズを設定
_drawing.prototype.setArrowSize = function(s) {
  var self = this;
  let list = {
    10: 'i-tool-arrow-size-1',
    20: 'i-tool-arrow-size-2',
    30: 'i-tool-arrow-size-3',
  };

  if ($.isNumeric(s)) {
    s = parseInt(s);
  } else {
    s = 10;
  }
  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );
  if (isSelect) {
    if (isLock) {
      return;
    }
    var history = self.historyInit();
    if (isSelectMulti) {
      _.each(self._target._objects, function(object) {
        if (!isEnableToolStyle('ARROW', object.type)) {
          return; // continue next object
        }
        if (object.arrowSize) {
          object.arrowSize = s;
          object.dirty = true;
          self.client.push({
            action: 'attribute',
            uuid: object.uuid,
            arrowSize: s,
          });
          const objectProperties = self.getObjectPropertiesInGroup(
            self._target,
            object
          );
          self.historyPush(object, history, {
            ...objectProperties,
          });
        }
      });
      $('.tool-line-size__value input').val(s);
      _.each(list, function(class_name) {
        $('#dropdown-border-arrow-size .selected-icon').removeClass(class_name);
      });
      $('#dropdown-border-arrow-size .selected-icon').addClass(
        list[parseInt(s)]
      );
      console.log('debug', `set target(s) arrow size (${s}).`);
    } else {
      if (self._target.arrowSize) {
        self._target.arrowSize = s;
        self._target.dirty = true;
        self.client.push({
          action: 'attribute',
          uuid: self._target.uuid,
          arrowSize: s,
        });
        self.historyPush(self._target, history, {});
        console.log('debug', `set target arrow size (${s}).`);
      }
    }
    const arrowTypeSelectedContent = $(`button.${list[s]}`).html();
    $('.tool-arrow-size__input-text').html(arrowTypeSelectedContent);
    self._canvas.requestRenderAll();
    self.client.flush();
    self.historySet('modify', history);
  }
};

// 背景の色を設定
_drawing.prototype.setBackgroundColor = function(
  c,
  is_send = true,
  isChangeAlphaOnly = false
) {
  var self = this;

  function setTextBackGroundColor(object, color, is_send) {
    object.set('backgroundColor', '');
    object.set('textBackgroundColor', color);
    object.dirty = true;
    if (is_send) {
      self.client.push({
        action: 'attribute',
        uuid: object.uuid,
        backgroundColor: color,
      });
    }
  }

  function fillColor(object, color, is_send) {
    object.dirty = true;
    object.fill = color;
    if (is_send) {
      self.client.push({
        action: 'attribute',
        uuid: object.uuid,
        fill: color,
      });
    }
  }

  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );
  if (isSelect) {
    if (isLock) {
      return;
    }
    let history = self.historyInit();
    if (isSelectMulti) {
      _.each(self._target._objects, function(object) {
        if (!isEnableToolStyle('BACKGROUND_COLOR', object.type)) {
          return; // continue next object
        }
        if (object.type === 'egText') {
          const newColor = getColorUpdate(
            c,
            object.textBackgroundColor,
            isChangeAlphaOnly
          );
          setTextBackGroundColor(object, newColor, is_send);
        } else {
          if (object.fill) {
            const newColor = getColorUpdate(c, object.fill, isChangeAlphaOnly);
            fillColor(object, newColor, is_send);
          }
        }
        const objectProperties = self.getObjectPropertiesInGroup(
          self._target,
          object
        );
        self.historyPush(object, history, {
          ...objectProperties,
        });
      });
      console.log('debug', `set target(s) background color (${c}).`);
    } else {
      if (self._target.type === 'egText') {
        setTextBackGroundColor(self._target, c, is_send);
        self.historyPush(self._target, history, {});
        console.log('debug', `set target background color (${c}).`);
      } else {
        if (self._target.fill) {
          fillColor(self._target, c, is_send);
          self.historyPush(self._target, history, {});
          console.log('debug', `set target background color (${c}).`);
        }
      }
    }
    self._canvas.requestRenderAll();
    self.client.flush();
    self.historySet('modify', history);
  }
};

// 文字の色を設定
_drawing.prototype.setTextColor = function(c) {
  var self = this;

  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );
  if (isSelect) {
    if (isLock) {
      return;
    }
    var history = self.historyInit();
    if (isSelectMulti) {
      _.each(self._target._objects, function(object) {
        if (object.type === 'egText') {
          object.fill = c;
          object.dirty = true;
          self.client.push({
            action: 'attribute',
            uuid: object.uuid,
            fill: c,
          });
          const objectProperties = self.getObjectPropertiesInGroup(
            self._target,
            object
          );
          self.historyPush(object, history, {
            ...objectProperties,
          });
        }
      });
      self._canvas.requestRenderAll();
      console.log('debug', `set target(s) text color (${c}).`);
    } else {
      if (self._target.type === 'egText') {
        self._target.fill = c;
        self._target.dirty = true;
        self._canvas.requestRenderAll();
        self.client.push({
          action: 'attribute',
          uuid: self._target.uuid,
          fill: c,
        });
        self.historyPush(self._target, history, {});
        console.log('debug', `set target text color (${c}).`);
      }
    }
    self.client.flush();
    self.historySet('modify', history);
  }
};

// 文字サイズを設定
_drawing.prototype.setFontSize = function(s) {
  var self = this;

  if ($.isNumeric(s)) {
    s = parseFloat(s);
  } else {
    s = 9;
  }
  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );
  if (isSelect) {
    if (isLock) {
      return;
    }
    var history = self.historyInit();
    if (isSelectMulti) {
      _.each(self._target._objects, function(object) {
        if (object.fontSize) {
          const fontSizeAfter = Math.round(s * 1.5);
          object.fontSize = fontSizeAfter;
          object.scaleX = 1.0;
          object.scaleY = 1.0;
          self.client.push({
            action: 'attribute',
            uuid: object.uuid,
            fontSize: fontSizeAfter,
          });
          const objectProperties = self.getObjectPropertiesInGroup(
            self._target,
            object
          );
          self.historyPush(object, history, {
            ...objectProperties,
          });
        }
      });
      self._canvas.requestRenderAll();
      console.log('debug', `set target(s) font size (${s}).`);
    } else {
      if (self._target.fontSize) {
        const fontSizeAfter = Math.round(s * 1.5);
        self._target.fontSize = fontSizeAfter;
        self._target.scaleX = 1.0;
        self._target.scaleY = 1.0;
        self._canvas.requestRenderAll();
        self.client.push({
          action: 'attribute',
          uuid: self._target.uuid,
          fontSize: fontSizeAfter,
        });
        self.historyPush(self._target, history, {});
        console.log('debug', `set target font size (${s}).`);
      }
    }
    self.client.flush();
    self.historySet('modify', history);
  }
};

// 背景画像設定
_drawing.prototype.setBackgroundFile = function(src) {
  var self = this;
  if (src === '') {
    self.clearBackgroundImage();
    return;
  }

  const loadSrc = headReplace(src, '/share/', `${API.nfs}/`);
  self._canvas.setBackgroundImage(loadSrc, function() {
    if (!_.isEmpty(self._canvas.backgroundImage)) {
      imageObjectSetScale(self._canvas.backgroundImage);
    }
    self._canvas.requestRenderAll();
    self.client.flushBackgroundImage(loadSrc);
    // 背景更新時にsendJsonが呼ばれてうまく他の端末に伝わらないので、
    // 更新タイムラグを設定
    setTimeout(() => {
      // BLDE_V2-12013対応
      self.client.flush();
    }, 500);
  });
};

// 背景画像設定(flushしない)
_drawing.prototype.setBackgroundFileNoFlush = function(
  src,
  socket,
  checkAllowRender = () => {
    return true;
  }
) {
  var self = this;
  if (src === '') {
    self.clearBackgroundImage();
    return;
  }

  const loadSrc = headReplace(src, '/share/', `${API.nfs}/`);
  self._canvas.setBackgroundImage(loadSrc, function() {
    if (!_.isEmpty(self._canvas.backgroundImage)) {
      imageObjectSetScale(self._canvas.backgroundImage);
    }
    if (checkAllowRender()) {
      self._canvas.requestRenderAll();
      self.client.flushBackgroundImage(loadSrc, socket);
    }
  });
};

// キャンバスから背景画像を取得する
// 内部を確認して作成したので使用には注意してください。意図しないタイミングで期待した値が取れないなどないとは言い切れないので。
_drawing.prototype.getBackgroundFile = function() {
  var self = this;
  try {
    console.log('getBackgroundFile self=', self._canvas.backgroundImage);
    //var src = self._canvas.backgroundImage._element.currentSrc;
    var src = self._canvas.backgroundImage._element.src;
    console.log('getBackgroundFile src=', src);
    if (src == null || src === undefined || src.trim() == '') {
      console.log('is null');
      return null;
    } else {
      console.log('is not null');
      return src;
    }
  } catch (e) {
    console.info(
      'backgroundImage object in Canvas',
      self._canvas.backgroundImage
    );
    return null;
  }
};

_drawing.prototype.getBackgroundImageScaledSize = function() {
  return {
    height: Math.floor(
      this._canvas.backgroundImage.height * this._canvas.backgroundImage.scaleY
    ),
    width: Math.floor(
      this._canvas.backgroundImage.width * this._canvas.backgroundImage.scaleX
    ),
  };
};

_drawing.prototype.setBackgroundFileKeyplan = function(src, printRange) {
  var self = this;
  src = src.replace('localhost:3000', 'host.docker.internal:3000');
  const loadSrc = headReplace(src, '/share/', `${API.nfs}/`);
  util.toDataURL(loadSrc, function(dataUrl) {
    self._canvas.setBackgroundImage(dataUrl, function() {
      //self._canvas.remove(self.backgroundPrint);
      imageObjectSetScale(self._canvas.backgroundImage);
      if (_.isUndefined(printRange)) {
        // 未設定の場合は背景のサイズに合わせる
        drawing.setBackgroundPrint({
          left: 0,
          top: 0,
          ...self.getBackgroundImageScaledSize(),
        });
      } else {
        drawing.setBackgroundPrint(printRange);
      }
      const relativePoint = drawing.client.getRelativePoint();
      drawing._canvas.relativePan(
        new fabric.Point(relativePoint.x, relativePoint.y)
      );
      self._canvas.requestRenderAll();
    });
  });
};

// 背景画像クリア

_drawing.prototype.clearBackgroundImage = function() {
  var self = this;

  self._canvas.backgroundImage = false;
  self._canvas.requestRenderAll();
  // BLDE_V2-12013対応
  self.client.flush();
  self.client.flushBackgroundImage();
};

// 画像設定
_drawing.prototype.addImage = function(src, partsMode = false) {
  // console.log('debug', 'addImage', src);

  var self = this;
  var scale;
  var isSelectable = false;

  if (partsMode) {
    scale = self._parts_scale;
    self._parts_url = '';
    isSelectable = true;
    ui.toolboxSelect('tool-select');
  } else {
    scale = 1.0;
  }

  fabric.EgImage.fromURL(src, function(img) {
    let topImg;
    let leftImg;

    if (partsMode) {
      topImg = self._pos.y;
      leftImg = self._pos.x;
    } else {
      // Set image to center of the canvas
      topImg =
        (self.backgroundPrint.height - img.height) / 2 +
        self.backgroundPrint.top;
      leftImg =
        (self.backgroundPrint.width - img.width) / 2 +
        self.backgroundPrint.left;
    }

    img.set({
      top: topImg,
      left: leftImg,
      width: img.width,
      height: img.height,
      scaleX: scale,
      scaleY: scale,
      selectable: isSelectable,
    });
    self._canvas.add(img);
    ui.toolboxSelect('tool-select');
    self.client.push({
      action: 'add',
      objects: [img.toObject()],
    });
    self.client.flush();
    var history = self.historyInit();
    self.historyPush(img, history);
    self.historySet('add', history);
    self._canvas.setActiveObject(img);
    self._canvas.requestRenderAll();
    if (isIPad()) {
      let $toolImage = $('.tool-image');
      $toolImage.css({
        backgroundColor: 'transparent',
      });
      $toolImage.removeClass('hover-image');
      $toolImage.click(() => {
        $toolImage.addClass('hover-image');
      });
    }
  });
};

// 複製
//  貼り付け時に行われる
_drawing.prototype.duplicateSelection = async function() {
  var self = this;
  var isGroupCopy = false;

  if (self._clipRoomId != self.client.getRoomId()) {
    self._offset = 0;
    self._clipRoomId = self.client.getRoomId();
  }

  var _push = function(o, x, y, f, originObject, history) {
    if (o.type == 'egGroup') {
      if (originObject) {
        o.set({
          angle: originObject.angle,
          flipX: originObject.flipX,
          flipY: originObject.flipY,
          width: originObject.width,
          height: originObject.height,
        });
      }
      isGroupCopy = true;
      var c = o.getCenterPoint();
      var g = [];
      _.each(o._objects, function(object, i) {
        let obj = null;
        if (originObject && originObject._objects[i]) {
          obj = originObject._objects[i];
          object.left = obj.left;
          object.top = obj.top;
        }

        _push(object, c.x, c.y, true, obj, history);
        g.push(object.uuid);
      });
      self.client.push({
        action: 'group',
        top: o.top,
        left: o.left,
        makeOnly: f,
        uuids: g,
        uuid: o.uuid,
        width: o.width,
        height: o.height,
        isGroupPaste: true,
        angle: o.angle,
        flipX: o.flipX,
        flipY: o.flipY,
      });
      if (f == false) {
        self.historyPush(o, history);
      }
    } else {
      self.client.push({
        action: 'add',
        makeOnly: f,
        objects: [o.toObject()],
      });
      if (f == false) {
        self.historyPush(o, history);
      }
    }

    // BLDE_V2-16295 対応のためコメントアウト（不要に連続で呼ばれIEなどで動作が遅くなる）
    //self.client.flush();
  };

  const correctPosGroupAndMultiSelect = function(target) {
    let correctTop = target.top + self._offset;
    let correctLeft = target.left + self._offset;
    if (target.originY === 'top') {
      correctTop += target.height / 2;
    }
    if (target.originX === 'left') {
      correctLeft += target.width / 2;
    }
    return { correctTop, correctLeft };
  };

  const objectClone = async function(target, offset) {
    const result = await self.deepCloneObjectAsync(target);
    result.set({
      top: result.top + offset,
      left: result.left + offset,
    });
    return result;
  };

  const { isSelect, isSelectMulti, isSelectOneGroup } = self.getSelectionStatus(
    self._target
  );

  if (isSelect) {
    if (isSelectMulti) {
      // 複数選択
      self._canvas.discardActiveObject();
      let cloneObjs = [];
      if (self.getTargetObjectCount() > self.getObjectRemainingCount()) {
        ui.showPopupMessage(
          'コピーしたオブジェクト数が設置できる残数を超えています'
        );
        self._target = undefined;
        return false;
      }
      const clonedObj = await self.deepCloneObjectAsync(self._target);
      self._canvas.discardActiveObject();
      clonedObj.set({
        left: clonedObj.left + self._offset,
        top: clonedObj.top + self._offset,
        evented: true,
      });
      clonedObj.canvas = self._canvas;
      const history = self.historyInit();
      for (let i = 0; i < _.size(clonedObj._objects); i++) {
        const destObj = await self.deepCloneObjectAsync(clonedObj._objects[i]);
        destObj.set({
          top: clonedObj.top + destObj.top + clonedObj.height / 2,
          left: clonedObj.left + destObj.left + clonedObj.width / 2,
        });
        self._canvas.add(destObj);
        cloneObjs.push(destObj);
        _push(destObj, 0, 0, false, undefined, history);
      }
      const activeSelections = new fabric.ActiveSelection(cloneObjs, {
        canvas: self._canvas,
      });
      clonedObj.setCoords();
      if (!self.isObjectCountLimitExceeded()) {
        self._canvas.setActiveObject(activeSelections);
      } else {
        self._target = undefined;
      }
      self.client.flush(isGroupCopy);
      self.historySet('add', history);
      self._offset = self._offset + 20;
      self._canvas.requestRenderAll();
    } else {
      // 単独選択時

      if (isSelectOneGroup) {
        // 単独選択のものがグループ化されている場合
        if (self.getTargetObjectCount() > self.getObjectRemainingCount()) {
          ui.showPopupMessage(
            'コピーしたオブジェクト数が設置できる残数を超えています'
          );
          self._target = undefined;
          return false;
        }
      } else {
        // 単独選択のものがグループ化されていない場合
        if (1 > self.getObjectRemainingCount()) {
          ui.showPopupMessage(
            'コピーしたオブジェクト数が設置できる残数を超えています'
          );
          self._target = undefined;
          return false;
        }
      }
      var sel = [];
      const history = self.historyInit();
      const destObj = await objectClone(self._target, self._offset);

      self._canvas.add(destObj);
      sel.push(destObj);
      _push(destObj, 0, 0, false, self._target, history);

      self.client.flush(isGroupCopy);
      self.historySet('add', history);
      self._canvas.discardActiveObject();

      if (isSelectOneGroup) {
        const { correctTop, correctLeft } = correctPosGroupAndMultiSelect(
          self._target
        );
        destObj.top = correctTop;
        destObj.left = correctLeft;
      }
      self._offset = self._offset + 20;

      self._canvas.fire('selection:created', {
        target: self._target,
      });
      destObj.setCoords();
      self._canvas.setActiveObject(destObj);
      self._canvas.requestRenderAll();
    }
  }
};
// 削除
_drawing.prototype.deleteSelection = function() {
  var self = this;
  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );
  if (isSelect) {
    if (isLock) {
      return;
    }
    var history = self.historyInit();

    if (isSelectMulti) {
      _.each(self._target._objects, function(item) {
        self.client.push({
          action: 'remove',
          uuid: item.uuid,
        });
        self.historyPush(item, history);
        fabric.eg.setUuid(item, item.uuid);
        self._canvas.remove(item);
      });
      self._canvas.fire('selection:cleared', {});
      self.client.flush();
      self._canvas.discardActiveObject();
    } else {
      self.client.push({
        action: 'remove',
        uuid: self._target.uuid,
      });
      self.historyPush(self._target, history);
      if (self._toolbox_selected === 'tool-point') {
        self.removeVertices(true, null);
      }
      self._canvas.remove(self._target);
      self.client.flush();
    }
    self.historySet('remove', history);
    self._canvas.requestRenderAll();
    self._target = undefined;
    self.setToolbarItem();
  }
};

// 全選択
_drawing.prototype.selectAll = function() {
  let self = this;
  self._canvas.discardActiveObject();
  ui.toolboxSelect('tool-select');
  const allKlassesExceptLowerLayer = self._canvas.getObjects().filter(o => {
    return !(
      o.globalCompositeOperation === 'destination-over' && o.neverSelectable
    );
  });
  if (allKlassesExceptLowerLayer && allKlassesExceptLowerLayer.length === 0) {
    return;
  }
  if (allKlassesExceptLowerLayer.length > 1) {
    self._canvas.forEachObject(function(o) {
      o.hasBorders = o.hasControls = false;
    });

    const selection = new fabric.ActiveSelection(allKlassesExceptLowerLayer, {
      canvas: self._canvas,
    });
    self._canvas.setActiveObject(selection);
  } else {
    // set active object when only have one object on canvas
    self._canvas.setActiveObject(allKlassesExceptLowerLayer[0]);
  }
  self._canvas.requestRenderAll();
};

//回転
_drawing.prototype.moveRotation = function(action) {
  var self = this;
  self._rotating = true;
  let angle = self._target.angle % 360;
  let events;
  switch (action) {
    case 'right-rotation':
      events = angle + self.shortcutRotationDegree;
      self._target.rotate(events);
      break;
    case 'left-rotation':
      events = angle - self.shortcutRotationDegree;
      self._target.rotate(events);
      break;
    default:
      break;
  }
};
//レイヤーの階層を一つ上に上げる
_drawing.prototype.moveFront = function() {
  var self = this;
  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );
  if (isSelect) {
    if (isLock) {
      return;
    }
    if (isSelectMulti) {
      // 複数選択
      var objects = [].concat(self._target._objects);

      // 配列をソート（表示位置順に）
      objects.sort(function(a, b) {
        var ap = self._canvas.getObjects().indexOf(a);
        var bp = self._canvas.getObjects().indexOf(b);
        if (ap < bp) {
          return 1;
        }
        if (ap > bp) {
          return -1;
        }
        return 0;
      });
      var activeObjects = self._canvas.getActiveObjects();
      self._canvas.discardActiveObject();

      var sel = [];

      // 全オブジェクトの変更前の zindex を記録する
      var history = self.historyInit();
      _.each(self._canvas.getObjects(), object => {
        self.historyPush(object, history);
      });

      var mostFront = false;
      _.each(objects, function(element) {
        if (mostFront) return true;
        var o = fabric.eg.getFromUuid(element.uuid);
        if (
          self._canvas.getObjects().indexOf(o) <
          self._canvas.getObjects().length - 1
        ) {
          o.bringForward();
          self.client.push({
            action: 'move-front',
            uuid: element.uuid,
          });
          sel.push(o);
        } else {
          mostFront = true;
        }
      });

      // 全オブジェクトの変更後の zindex をstates_afterに記録する
      _.each(history.objects, (object, i) => {
        history.states_after[i].zindex = self._canvas
          .getObjects()
          .indexOf(object);
      });

      self.client.flush();
      self.historySet('zindex', history);
      var activeSelection = new fabric.ActiveSelection(activeObjects, {
        canvas: self._canvas,
      });
      self._canvas.setActiveObject(activeSelection);
      self._canvas.requestRenderAll();
    } else {
      // 単独選択

      // 全オブジェクトの変更前の zindex を記録する
      var history = self.historyInit();
      _.each(self._canvas.getObjects(), object => {
        self.historyPush(object, history);
      });

      self._target.bringForward();

      // 全オブジェクトの変更後の zindex をstates_afterに記録する
      _.each(history.objects, (object, i) => {
        history.states_after[i].zindex = self._canvas
          .getObjects()
          .indexOf(object);
      });

      self._canvas.requestRenderAll();
      self.client.push({
        action: 'move-front',
        uuid: self._target.uuid,
      });
      self.client.flush();
      self.historySet('zindex', history);
    }
  }
  ui.checkDisableMoveFrontOrBack(self._canvas, self._canvas.getActiveObject());
};

// 最前面に
_drawing.prototype.moveMostFront = function() {
  var self = this;
  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );
  if (isSelect) {
    if (isLock) {
      return;
    }
    if (isSelectMulti) {
      // 複数選択
      var objects = [].concat(self._target._objects);

      // 配列をソート（表示位置順に）
      objects.sort(function(a, b) {
        var ap = self._canvas.getObjects().indexOf(a);
        var bp = self._canvas.getObjects().indexOf(b);
        if (ap > bp) {
          return 1;
        }
        if (ap < bp) {
          return -1;
        }
        return 0;
      });

      var activeObjects = self._canvas.getActiveObjects();
      self._canvas.discardActiveObject();

      var sel = [];

      // 全オブジェクトの変更前の zindex を記録する
      var history = self.historyInit();
      _.each(self._canvas.getObjects(), object => {
        self.historyPush(object, history);
      });

      _.each(objects, function(element) {
        var o = fabric.eg.getFromUuid(element.uuid);
        o.bringToFront();
        self.client.push({
          action: 'move-most-front',
          uuid: element.uuid,
        });
        sel.push(o);
      });

      // 全オブジェクトの変更後の zindex をstates_afterに記録する
      _.each(history.objects, (object, i) => {
        history.states_after[i].zindex = self._canvas
          .getObjects()
          .indexOf(object);
      });

      self.client.flush();
      self.historySet('zindex', history);
      var activeSelection = new fabric.ActiveSelection(activeObjects, {
        canvas: self._canvas,
      });
      self._canvas.setActiveObject(activeSelection);
      self._canvas.requestRenderAll();
    } else {
      // 単独選択

      // 全オブジェクトの変更前の zindex を記録する
      var history = self.historyInit();
      _.each(self._canvas.getObjects(), object => {
        self.historyPush(object, history);
      });

      self._target.bringToFront();

      // 全オブジェクトの変更後の zindex をstates_afterに記録する
      _.each(history.objects, (object, i) => {
        history.states_after[i].zindex = self._canvas
          .getObjects()
          .indexOf(object);
      });

      self._canvas.requestRenderAll();
      self.client.push({
        action: 'move-most-front',
        uuid: self._target.uuid,
      });
      self.client.flush();
      self.historySet('zindex', history);
    }
  }
  ui.checkDisableMoveFrontOrBack(self._canvas, self._canvas.getActiveObject());
};

// 背面に
_drawing.prototype.moveBack = function() {
  var self = this;
  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );
  if (isSelect) {
    if (isLock) {
      return;
    }
    if (isSelectMulti) {
      // 複数選択
      var elements = [].concat(self._target._objects);

      // 配列をソート（表示位置順に）
      elements.sort(function(a, b) {
        var ap = self._canvas.getObjects().indexOf(a);
        var bp = self._canvas.getObjects().indexOf(b);
        if (ap > bp) {
          return 1;
        }
        if (ap < bp) {
          return -1;
        }
        return 0;
      });
      var activeObjects = self._canvas.getActiveObjects();
      self._canvas.discardActiveObject();

      var sel = [];

      // 全オブジェクトの変更前の zindex を記録する
      var history = self.historyInit();
      _.each(self._canvas.getObjects(), object => {
        self.historyPush(object, history);
      });

      var mostBack = false;
      _.each(elements, function(element) {
        if (mostBack) return true;
        var o = fabric.eg.getFromUuid(element.uuid);

        if (_.isUndefined(o._stateProperties)) {
          o._stateProperties = {};
        }
        o._stateProperties.zindex = self._canvas.getObjects().indexOf(o);

        if (self._canvas.getObjects().indexOf(o) > 0) {
          o.sendBackwards();
          self.client.push({
            action: 'move-back',
            uuid: element.uuid,
          });
          sel.push(o);
        } else {
          mostBack = true;
        }
      });

      // 全オブジェクトの変更後の zindex をstates_afterに記録する
      _.each(history.objects, (object, i) => {
        history.states_after[i].zindex = self._canvas
          .getObjects()
          .indexOf(object);
      });

      self.client.flush();
      self.historySet('zindex', history);
      var activeSelection = new fabric.ActiveSelection(activeObjects, {
        canvas: self._canvas,
      });
      self._canvas.setActiveObject(activeSelection);
      self._canvas.requestRenderAll();
    } else {
      // 単独選択

      // 全オブジェクトの変更前の zindex を記録する
      var history = self.historyInit();
      _.each(self._canvas.getObjects(), object => {
        self.historyPush(object, history);
      });

      self._target.sendBackwards();

      // 全オブジェクトの変更後の zindex をstates_afterに記録する
      _.each(history.objects, (object, i) => {
        history.states_after[i].zindex = self._canvas
          .getObjects()
          .indexOf(object);
      });

      self._canvas.requestRenderAll();
      self.client.push({
        action: 'move-back',
        uuid: self._target.uuid,
      });
      self.client.flush();
      self.historySet('zindex', history);
    }
  }
  ui.checkDisableMoveFrontOrBack(self._canvas, self._canvas.getActiveObject());
};
// 最背面に
_drawing.prototype.moveMostBack = function() {
  var self = this;
  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );
  if (isSelect) {
    if (isLock) {
      return;
    }
    if (isSelectMulti) {
      // 複数選択
      var elements = [].concat(self._target._objects);

      // 配列をソート（表示位置順に）
      elements.sort(function(a, b) {
        var ap = self._canvas.getObjects().indexOf(a);
        var bp = self._canvas.getObjects().indexOf(b);
        if (ap < bp) {
          return 1;
        }
        if (ap > bp) {
          return -1;
        }
        return 0;
      });
      var activeObjects = self._canvas.getActiveObjects();
      self._canvas.discardActiveObject();

      var sel = [];

      // 全オブジェクトの変更前の zindex を記録する
      var history = self.historyInit();
      _.each(self._canvas.getObjects(), object => {
        self.historyPush(object, history);
      });

      _.each(elements, function(element) {
        var o = fabric.eg.getFromUuid(element.uuid);

        if (_.isUndefined(o._stateProperties)) {
          o._stateProperties = {};
        }
        o._stateProperties.zindex = self._canvas.getObjects().indexOf(o);

        o.sendToBack();
        self.client.push({
          action: 'move-most-back',
          uuid: element.uuid,
        });
        sel.push(o);
      });

      // 全オブジェクトの変更後の zindex をstates_afterに記録する
      _.each(history.objects, (object, i) => {
        history.states_after[i].zindex = self._canvas
          .getObjects()
          .indexOf(object);
      });

      self.client.flush();
      self.historySet('zindex', history);
      var activeSelection = new fabric.ActiveSelection(activeObjects, {
        canvas: self._canvas,
      });
      self._canvas.setActiveObject(activeSelection);
      self._canvas.requestRenderAll();
    } else {
      // 単独選択

      // 全オブジェクトの変更前の zindex を記録する
      var history = self.historyInit();
      _.each(self._canvas.getObjects(), object => {
        self.historyPush(object, history);
      });

      self._target.sendToBack();

      // 全オブジェクトの変更後の zindex をstates_afterに記録する
      _.each(history.objects, (object, i) => {
        history.states_after[i].zindex = self._canvas
          .getObjects()
          .indexOf(object);
      });

      self._canvas.requestRenderAll();
      self.client.push({
        action: 'move-most-back',
        uuid: self._target.uuid,
      });
      self.client.flush();
      self.historySet('zindex', history);
    }
  }
  ui.checkDisableMoveFrontOrBack(self._canvas, self._canvas.getActiveObject());
};

// グループ化
_drawing.prototype.makeGroup = async function(isUndoOrRedo, angle, oldGroup) {
  var self = this;
  const history = self.historyInit();
  console.log('debug', 'makeGroup');

  const {
    isSelect,
    isSelectMulti,
    isSelectMultiAnyLock,
  } = self.getSelectionStatus(self._target);
  if (!isUndoOrRedo) {
    history.sortedUUIDs = _.map(self._canvas.getObjects(), 'uuid');
  }

  if (!isSelect) {
    return;
  }
  if (!isSelectMulti) {
    return;
  }
  if (isSelectMultiAnyLock) {
    return;
  }
  if (isUndoOrRedo == null) {
    isUndoOrRedo = false;
  }
  var elements = self._target._objects;
  var gelms = new Array();
  var uuids = new Array();
  var elmPos = [];
  const target = self._target;
  self._canvas.discardActiveObject();

  // 配列をソート（表示位置順に）
  elements.sort(function(a, b) {
    var ap = self._canvas.getObjects().indexOf(a);
    var bp = self._canvas.getObjects().indexOf(b);
    if (ap > bp) {
      return 1;
    }
    if (ap < bp) {
      return -1;
    }
    return 0;
  });
  // 基準位置を取得
  for (let i = 0; i < _.size(elements); i++) {
    const element = elements[i];
    const clonedObject = fabric.eg.getFromUuid(element.uuid);
    clonedObject.hasBorders = false;
    gelms.push(clonedObject);
    uuids.push(clonedObject.uuid);
    elmPos.push({
      top: clonedObject.top,
      left: clonedObject.left,
    });
    self._canvas.remove(element);
  }
  let group = new fabric.EgGroup(gelms, {
    width: target.width,
    height: target.height,
  });

  if (isUndoOrRedo) {
    if (angle != null) {
      group.angle = angle;
    }
    group.uuid = oldGroup.uuid;
    group.created = oldGroup.created;
    group.updated = oldGroup.updated;
    fabric.eg.setUuid(group, oldGroup.uuid);
  }
  self._canvas.add(group);
  if (!isUndoOrRedo) {
    const id = self._canvas.getObjects().indexOf(group);
    self._canvas.setActiveObject(self._canvas.item(id).addWithUpdate());
    self._canvas.fire('object:selected', {
      target: self._canvas.item(id),
    });
  }
  self._canvas.requestRenderAll();

  // 送信
  self.client.push({
    action: 'group',
    top: target.top,
    left: target.left,
    width: target.width,
    height: target.height,
    uuids,
    isUndoOrRedo,
    elmPos,
    angle,
    uuid: group.uuid,
  });
  self.client.flush();

  if (!isUndoOrRedo) {
    self.historyPush(group, history);
    self.historySet('group', history);
  }

  if (isSelectMultiAnyLock) {
    // 選択オブジェクトにロックオブジェクトが含まれている場合
    // グループ化オブジェクトもロックする
    self.lock();
  }
  $('#tab-tool-home, #tab-tool-home__link').removeClass('active');
  $('#tab-tool-edit, #tab-tool-edit__link').addClass('active');
  ui.checkDisableMoveFrontOrBack(self._canvas, self._canvas.getActiveObject());
  // Disable all tool setting style when click make group objects
  $('.tool-setting-style').addClass('pointer-events-none');
};

// グループ化解除
_drawing.prototype.ungroup = function(isUndoOrRedo) {
  var self = this;
  const history = self.historyInit();

  const { isSelect, isSelectOneGroup, isLock } = self.getSelectionStatus(
    self._target
  );
  if (!isUndoOrRedo) {
    history.sortedUUIDs = _.map(self._canvas.getObjects(), 'uuid');
  }
  if (isSelect) {
    if (isSelectOneGroup && !isLock) {
      let group = self._target;
      if (isUndoOrRedo) {
        group = fabric.eg.getFromUuid(self._target.uuid);
      }
      let itemsInGroups = group._objects;
      group._restoreObjectsState();
      self._canvas.remove(group);
      _.each(itemsInGroups, function(object) {
        object.dirty = object.hasBorders = object.hasControls = true;
        fabric.eg.setUuid(object, object.uuid);
        self._canvas.add(object);
      });
      self._canvas.requestRenderAll();
      self.client.push({
        action: 'ungroup',
        uuid: group.uuid,
      });
      self.client.flush();
      if (!isUndoOrRedo) {
        self.historyPush(group, history);
        self.historySet('ungroup', history);
      }
    }
  }
  ui.checkDisableMoveFrontOrBack(self._canvas, self._canvas.getActiveObject());
  ui.enableToolStyleSwipeObject(self._target);
};

// ポリゴン・ポリライン描画完了
_drawing.prototype.addPoly = function() {
  var self = this;
  var points = self._making.points;

  //ダブルクリックで同座標に2点作成された場合は描写しない
  if (self._toolbox_selected == 'tool-polygon' && points.length - 1 == 2) {
    if (
      Math.abs(points[0].x) == Math.abs(points[1].x) &&
      Math.abs(points[0].y) == Math.abs(points[1].y)
    ) {
      return;
    }
  }

  if (self._making) {
    var p;
    points = self.formatVertices(points);
    var min_x = _.min(_.map(points, 'x'));
    var min_y = _.min(_.map(points, 'y'));
    var options = {
      top: self._making.top + min_y,
      left: self._making.left + min_x,
      fill: self._toolbar_picker_background,
      stroke: self._toolbar_picker_foreground,
      strokeWidth: self._toolbar_border,
      strokeDashArray: _.isEqual(self._toolbar_border_style, [1, 0])
        ? []
        : self._toolbar_border_style,
      selectable: false,
    };

    if (self._toolbox_selected == 'tool-polyline') {
      var as = self._toolbar_arrow_type == 2 || self._toolbar_arrow_type == 3;
      var ae = self._toolbar_arrow_type == 1 || self._toolbar_arrow_type == 3;
      options.arrowStart = as;
      options.arrowEnd = ae;
      options.arrowSize = self._toolbar_arrow_size;
      options.fill = 'rgba(255,255,255,0)';
      p = new fabric.EgPolyline(points, options);
    } else {
      p = new fabric.EgPolygon(points, options);
    }

    self._canvas.remove(self._making);
    self._canvas.add(p);
    self.client.push({
      action: 'add',
      objects: [p.toObject()],
    });
    self.client.flush();
    var history = self.historyInit();
    self.historyPush(p, history);
    self.historySet('add', history);
    self._making = undefined;
    ui.toolboxSelect('tool-select');
    self._currentPolygonUuid = p.uuid;
    fabric.eg.setUuid(p, self._currentPolygonUuid);
    if (checkObjectCount(self._canvas)) {
      self._canvas.setActiveObject(p);
      self._canvas.requestRenderAll();
    } else {
      self._currentPolygonUuid = undefined;
    }
  }
};

// ポリゴン・ポリライン描画取消
_drawing.prototype.deletePoly = function() {
  var self = this;

  if (self._making) {
    var idx = self._making.points.length - 1;
    if (idx == 1) {
      self._canvas.remove(self._making);
      self._making = undefined;
    } else {
      self._making.points.splice(idx, 1);
    }
    self._canvas.requestRenderAll();
  }
};

/**
 * オブジェクトロック
 */
_drawing.prototype.lock = function(isUndoOrRedo) {
  var self = this;
  console.log('debug', 'lock');

  var timeStamp = util.getTimeStamp();
  var userType = userinfo.getUserType();
  var userName = userinfo.getUserName();
  var companyName = userinfo.getUserCompanyName();
  var userId = userinfo.getUserId();
  var lockManagerId = -1;
  var lockForemanId = -1;

  if (isPrimaryCompany(userType)) {
    lockManagerId = userId;
  } else {
    lockForemanId = userId;
  }

  const { isSelect, isSelectMulti, canLock } = self.getSelectionStatus(
    self._target
  );
  if (!isSelect || !canLock) {
    return;
  }
  var history = self.historyInit();

  // 単独選択、複数選択、ともに外枠にロックしたことを示す色を付属させる
  self._target.set({
    locked: timeStamp,
    lockManager: lockManagerId,
    lockForeman: lockForemanId,
    lockerName: userName,
    lockerCompanyName: companyName,
  });

  if (isSelectMulti) {
    // 複数選択
    _.each(self._target._objects, function(object) {
      object.set({
        locked: timeStamp,
        lockManager: lockManagerId,
        lockForeman: lockForemanId,
        lockerName: userName,
        lockerCompanyName: companyName,
      });
      self.client.push({
        action: 'attribute',
        uuid: object.uuid,
        locked: timeStamp,
        lockManager: lockManagerId,
        lockForeman: lockForemanId,
        lockerName: userName,
        lockerCompanyName: companyName,
      });
      if (!isUndoOrRedo) {
        const objectProperties = self.getObjectPropertiesInGroup(
          self._target,
          object
        );
        self.historyPush(object, history, {
          ...objectProperties,
        });
      }
    });
  } else {
    // 単独選択
    self.client.push({
      action: 'attribute',
      uuid: self._target.uuid,
      locked: timeStamp,
      lockManager: lockManagerId,
      lockForeman: lockForemanId,
      lockerName: userName,
      lockerCompanyName: companyName,
    });
    if (!isUndoOrRedo) {
      self.historyPush(self._target, history, {});
    }
  }
  self.updateScreen();
  self.client.flush();
  if (!isUndoOrRedo) {
    self.historySet('lock', history);
  }
  ui.enableToolStyleSwipeObject(self._target);
};

/**
 * オブジェクトロック解除
 */
_drawing.prototype.unlock = function(isUndoOrRedo) {
  var self = this;

  const { isSelect, isSelectMulti, canUnlock } = self.getSelectionStatus(
    self._target
  );

  if (!isSelect || !canUnlock) {
    return;
  }

  var history = self.historyInit();
  if (isSelectMulti) {
    // 複数選択
    _.each(self._target._objects, function(object) {
      object.set({
        locked: 0,
        lockManager: -1,
        lockForeman: -1,
        lockerName: '',
        lockerCompanyName: '',
        // BLDE_V2-17298対応
        lockMovementY: false,
        lockMovementX: false,
        lockScalingY: false,
        lockScalingX: false,
        lockRotation: false,
      });
      self.client.push({
        action: 'attribute',
        uuid: object.uuid,
        locked: 0,
        lockManager: -1,
        lockForeman: -1,
        lockerName: '',
        lockerCompanyName: '',
      });
      if (!isUndoOrRedo) {
        const objectProperties = self.getObjectPropertiesInGroup(
          self._target,
          object
        );
        self.historyPush(object, history, {
          ...objectProperties,
        });
      }
    });
  } else {
    // 単独選択
    self._target.set({
      locked: 0,
      lockManager: -1,
      lockForeman: -1,
      lockerName: '',
      lockerCompanyName: '',
    });
    self.client.push({
      action: 'attribute',
      uuid: self._target.uuid,
      locked: 0,
      lockManager: -1,
      lockForeman: -1,
      lockerName: '',
      lockerCompanyName: '',
    });
    if (!isUndoOrRedo) {
      self.historyPush(self._target, history, {});
    }
  }
  self.updateScreen();
  self.client.flush();
  if (!isUndoOrRedo) {
    self.historySet('unlock', history);
  }
  let targetType = self._target.type;

  // activeSelection is multiple object
  if (targetType === 'activeSelection') {
    $('.layout-tool__item.pointer-events-none').removeClass(
      'pointer-events-none'
    );
  } else {
    ui.checkToolToDisable(self._target.type);
  }
  // ui.checkDisableMoveFrontOrBack(self._canvas, self._canvas.getActiveObject());
  ui.enableToolStyleSwipeObject(self._target);
  ui.checkDisableMoveFrontOrBack(self._canvas, self._canvas.getActiveObject());
  ui.enableToolStyleSwipeObject(self._target);
  let statuses = self.getSelectionStatus(self._target);
  let { isSelectOneGroup } = statuses;
  if (isSelectOneGroup) {
    ui.styleWithGroupLocked(statuses);
  }
  ui.styleWithTargetLocked(statuses, self._target);
};

// コピー
_drawing.prototype.copy = async function(isCut = false) {
  var self = this;
  self._offset = 20;
  const { isSelect, isSelectMulti, isLock } = self.getSelectionStatus(
    self._target
  );

  if (isSelect) {
    if (isLock && isCut) {
      return;
    }

    if (isSelectMulti) {
      //when fabric clone multiple, children objects' UUIDs are not changed

      const clonedObject = _.cloneDeep(self._target);
      for (let i = 0; i < clonedObject._objects.length; ++i) {
        //clone each child object first to renew uuid
        clonedObject._objects[i] = await self.deepCloneObjectAsync(
          clonedObject._objects[i]
        );
      }
      self._clip = await self.deepCloneObjectAsync(clonedObject);
    } else {
      self._clip = await self.deepCloneObjectAsync(self._target);
    }

    self._clipRoomId = self.client.getRoomId();
    self._clipOrder = [];
    if (isSelectMulti) {
      // 複数選択なら ClipOrder 配列に値を入れる
      _.each(self._target._objects, function(object, i) {
        self._clipOrder.push({
          index: i,
          zIndex: self._canvas.getObjects().indexOf(object),
        });
      });
      self._clipOrder.sort(function(a, b) {
        if (a.zIndex > b.zIndex) {
          return 1;
        }
        if (a.zIndex < b.zIndex) {
          return -1;
        }
        return 0;
      });
    }
    if (isCut) {
      self.deleteSelection();
    } else {
      self._canvas.discardActiveObject().requestRenderAll();
      self.setToolbarItem();
    }
  }
};

// 貼り付け
// 連打対策でthrottleしている。連打されるとこの処理だけでスレッドが使われて他の非同期処理の結果が返ってこなくなる
_drawing.prototype.paste = _.throttle(function() {
  var self = this;
  self._canvas.discardActiveObject();
  if (self._clip) {
    self._target = self._clip;
    self.duplicateSelection();
  }
}, 100);

// undo
_drawing.prototype.undo = function(isUndo = true) {
  var self = this;
  var history;
  self.removeEditPoints();
  if (isUndo) {
    if (!historyFilo.isPrev()) {
      return;
    }
    history = historyFilo.prev();
  } else {
    if (!historyFilo.isNext()) {
      return;
    }
    history = historyFilo.next();
  }

  if (!history) {
    self.setToolbarItem();
    return;
  }

  var action;
  var states;
  var objects = history.objects;
  _.each(objects, function(object, i) {
    objects[i] = fabric.eg.getFromUuid(object.uuid);
  });
  // console.log('drawing.js _drawing.prototype.undo', history, fifo);
  if (isUndo) {
    states = history.states_before;
    if (history.action === 'add') {
      action = 'remove';
    } else if (history.action === 'remove') {
      action = 'add';
    } else if (history.action === 'group') {
      action = 'ungroup';
    } else if (history.action === 'ungroup') {
      action = 'group';
    } else if (history.action === 'lock') {
      action = 'unlock';
    } else if (history.action === 'unlock') {
      action = 'lock';
    } else {
      action = history.action;
    }
  } else {
    states = history.states_after;
    action = history.action;
  }

  self._canvas.discardActiveObject();

  switch (action) {
    case 'add':
      _.each(objects, function(object) {
        var item = _.extend({}, object);
        var msg = {
          action: 'add',
          objects: [item],
        };
        self._canvas.add(object);
        self.client.push(msg);
      });
      self.client.flush();
      self._canvas.requestRenderAll();
      break;

    case 'remove':
      _.each(objects, function(object) {
        self._canvas.remove(object);
        var msg = {
          action: 'remove',
          uuid: object.uuid,
        };
        self.client.push(msg);
      });
      self.client.flush();
      self._canvas.requestRenderAll();
      break;

    case 'modify':
      _.each(objects, function(object, i) {
        var sx = 1;
        var sy = 1;
        var state = { ...states[i] };

        if (object.type === 'egGroup') {
          delete state.flipX;
          delete state.flipY;

          object.setOptions(state);

          if (
            history.states_before[i].flipX === !history.states_after[i].flipX
          ) {
            object.setOptions({
              flipX: !object.flipX,
            });
            state.hasFlipX = true;
          }

          if (
            history.states_before[i].flipY === !history.states_after[i].flipY
          ) {
            object.setOptions({
              flipY: !object.flipY,
            });
            state.hasFlipY = true;
          }

          sx = states[i].sx;
          sy = states[i].sy;

          if (sx && sy) {
            _.each(object._objects, function(inner_object) {
              inner_object.left *= sx;
              inner_object.top *= sy;
              inner_object.resizeToScale(sx, sy, true, undefined, isUndo);
            });
          }
        } else if (object.type === 'customFreehand') {
          object.setOptions(states[i]);
          if (states[i].strokeSize) {
            updateFreehandGroupThickness(object, states[i].strokeSize);
          }
          if (states[i].strokeColor) {
            updateCustomFreehandColor(object, states[i].strokeColor);
          }
          states[i].top && (object.top = states[i].top);
          states[i].left && (object.left = states[i].left);
        } else {
          object.setOptions(states[i]);
          // undo, redo not working properly for line if not set top and left manually
          states[i].top && (object.top = states[i].top);
          states[i].left && (object.left = states[i].left);
        }
        object.setCoords();
        state.sx = sx;
        state.sy = sy;
        var msg = {
          action: 'modify',
          uuid: object.uuid,
          options: state,
        };
        self.client.push(msg);
        self.historyPush(object, self.historyInit());
      });
      self.client.flush();
      self._canvas.requestRenderAll();
      break;

    case 'zindex':
      if (isUndo) {
        _.each(objects, object => {
          object.bringToFront();
        });
      } else {
        // Redo 時には sates に history.state_after の値が入るので
        // そこから保持しておいた zindex を取得して並び替える
        const sortObjects = [...objects];
        sortObjects.sort((a, b) => {
          const aIndex = states[objects.indexOf(a)].zindex;
          const bIndex = states[objects.indexOf(b)].zindex;
          if (aIndex > bIndex) {
            return 1;
          }
          if (aIndex < bIndex) {
            return -1;
          }
          return 0;
        });

        // 並び替えた通りに bringToFront で再配置する
        _.each(sortObjects, object => {
          object.bringToFront();
        });
      }
      self.client.flush();
      self._canvas.requestRenderAll();
      break;

    case 'group':
      var group = objects[0];
      var elements = group._objects;

      _.each(elements, function(element, i) {
        elements[i] = fabric.eg.getFromUuid(element.uuid);
      });

      var angle = null;

      if (isUndo && group.angle !== 0) {
        angle = group.angle;
        // below function works only if group origin = center
        group.originX = 'center';
        group.originY = 'center';
        var center = group.getCenterPoint();
        var unRad = fabric.util.degreesToRadians(180 - angle);
        var zeroPoint = new fabric.Point(0, 0);

        _.each(elements, function(element) {
          var left = center.x - element.left;
          var top = center.y - element.top;
          var point = fabric.util.rotatePoint(
            new fabric.Point(left, top),
            zeroPoint,
            unRad
          );

          element.left = center.x + point.x;
          element.top = center.y + point.y;
          element.angle -= angle;
        });
      }
      self._canvas.discardActiveObject();
      const sel = new fabric.ActiveSelection(elements, {
        canvas: self._canvas,
      });
      self._canvas.setActiveObject(sel);
      self.makeGroup(true, angle, group);
      if (isUndo) {
        sortObjectsByIndex(self, history);
      }
      break;

    case 'ungroup':
      var group = objects[0];
      self._target = group;
      self.ungroup(true);
      if (isUndo) {
        sortObjectsByIndex(self, history);
      }
      self._target = undefined;
      break;

    case 'lock':
      _.each(objects, function(object) {
        self._target = object;
        self.lock(true);
      });
      self._target = undefined;
      break;

    case 'unlock':
      _.each(objects, function(object) {
        self._target = object;
        self.unlock(true);
      });
      self._target = undefined;
      break;

    default:
      break;
  }
  self.setToolbarItem();
};

// redo
_drawing.prototype.redo = function() {
  var self = this;
  self.undo(false);
};

// undo/redo 履歴保存の初期化
_drawing.prototype.historyBufferInit = function() {
  historyFilo.clear();
};

// undo 履歴保存の初期化
_drawing.prototype.historyInit = function() {
  return {
    objects: [],
    states_before: [],
    states_after: [],
  };
};

/**
 * undo 履歴に蓄積する
 *  historyオブジェクト
 *    (objects, states_before, states_after の各配列を持つ)
 *  に対して、object で指定したものの状態を記録する。
 *  変更前の状態は states_before に格納し
 *  変更後の状態は states_after に格納する
 */
_drawing.prototype.historyPush = function(object, history, stateAfter) {
  var self = this;

  if (_.isUndefined(object._stateProperties)) {
    object._stateProperties = {};
  }

  var state = { ...object._stateProperties };
  if (object.sx && object.sy) {
    state.sx = 1 / object.sx;
    state.sy = 1 / object.sy;
  }

  if (object.type === 'egGroup') {
    delete state.fill;
    delete state.stroke;
    delete state.strokeWidth;
  }
  if (_.isUndefined(stateAfter)) {
    delete state.top;
    delete state.left;
  }
  history.objects.push(object);
  history.states_before.push(state);

  object.saveState(self.stateProperties);
  state = { ...object._stateProperties };
  if (object.sx && object.sy) {
    state.sx = object.sx;
    state.sy = object.sy;
  }

  if (object.type === 'egGroup') {
    delete state.fill;
    delete state.stroke;
    delete state.strokeWidth;
  }
  if (_.isObject(stateAfter)) {
    if (stateAfter.top) {
      object._stateProperties.top = stateAfter.top;
      state.top = stateAfter.top;
    }

    if (stateAfter.left) {
      object._stateProperties.left = stateAfter.left;
      state.left = stateAfter.left;
    }

    if (stateAfter.angle) {
      object._stateProperties.angle = stateAfter.angle;
      state.angle = stateAfter.angle;
    }

    if (stateAfter.flipX) {
      object._stateProperties.flipX = stateAfter.flipX;
      state.flipX = stateAfter.flipX;
    }

    if (stateAfter.flipY) {
      object._stateProperties.flipY = stateAfter.flipY;
      state.flipY = stateAfter.flipY;
    }

    if (stateAfter.zindex) {
      object._stateProperties.zindex = stateAfter.zindex;
      state.zindex = stateAfter.zindex;
    }
  }
  history.states_after.push(state);
};

// 履歴を保存
//  hisotoryオブジェクトを fifo オブジェクトに格納する
_drawing.prototype.historySet = function(action, history) {
  // console.log('drawing.js', 'historySet', action);

  var self = this;

  if (history.objects.length > 0) {
    history.action = action;
    historyFilo.set(history);
  }
  self.setToolbarItem();
};

_drawing.prototype.disableZoom = function(zoom) {
  const toolbarZoomdown = $('.toolbar-zoomdown');
  const toolbarZoomup = $('.toolbar-zoomup');
  if (zoom === drawing.minZoom) {
    toolbarZoomdown.hover(function() {
      $(this).css('background-color', '#F2F2F2');
    });
    toolbarZoomdown
      .closest('.layout-tool__item')
      .addClass('pointer-events-none');
    toolbarZoomup
      .closest('.layout-tool__item')
      .removeClass('pointer-events-none');
  } else if (zoom === drawing.maxZoom) {
    toolbarZoomup.hover(function() {
      $(this).css('background-color', '#F2F2F2');
    });
    toolbarZoomup.closest('.layout-tool__item').addClass('pointer-events-none');
    toolbarZoomdown
      .closest('.layout-tool__item')
      .removeClass('pointer-events-none');
  } else {
    $('.toolbar-zoomdown, .toolbar-zoomup').hover(
      function() {
        $(this).css('background-color', '#C2DDFF');
      },
      function() {
        $(this).css('background-color', '#F2F2F2');
      }
    );
    $('.toolbar-zoomup, .toolbar-zoomdown')
      .closest('.layout-tool__item')
      .removeClass('pointer-events-none');
  }
};

// ズーム
_drawing.prototype.setZoom = function(zoom, x, y) {
  let self = this;
  console.log('debug', `set zoom: ${zoom},${x},${y}`);
  if (zoom > 8.0) {
    zoom = 8.0;
  }
  if (zoom < 0.25) {
    zoom = 0.25;
  }
  // case reset zoom = 1
  if (typeof x === 'undefined' && typeof y === 'undefined') {
    const zoomPoints = self.getZoomPoints();
    x = zoomPoints.pointX;
    y = zoomPoints.pointY;
  }
  self._canvas.zoomToPoint(new fabric.Point(x, y), zoom);
  self._zoom = zoom;
  self.disableZoom(zoom);
  self._canvas.requestRenderAll();
};
//get zoom points
_drawing.prototype.getZoomPoints = function() {
  let self = this;
  let pointX;
  let pointY;
  const viewport = self._canvas.viewportTransform;
  const target = self._target ? self._target : self.backgroundPrint;
  pointX = (target.left + target.width / 2) * self._zoom + viewport[4];
  pointY = (target.top + target.height / 2) * self._zoom + viewport[5];
  return { pointX, pointY };
};

// ズームアップ
_drawing.prototype.zoomUp = function() {
  $('#dropdown-zoom-level .select-up-reverse').trigger('click');
  let container = $('.tool-item--sm.selected');
  $(container).removeClass('selected');
};
// ズームダウン
_drawing.prototype.zoomDown = function() {
  $('#dropdown-zoom-level .select-down-reverse').trigger('click');
  let container = $('.tool-item--sm.selected');
  $(container).removeClass('selected');
};

// 印刷範囲指定フレームの表示
_drawing.prototype.showPrintFrame = function(printRange) {
  if (_.isEmpty(printRange)) {
    throw new Error('showPrintFrame: args(printRange) is Empty.');
  }

  var self = this;
  var printFrame = {};

  const top = printRange.top;
  const left = printRange.left;
  const width = printRange.width;
  const height = printRange.height;

  $('[data-id="m_layout_etc"]').addClass('__is-selected');
  self.canvasAllObjectsSelectableChange(false);
  printFrame = new fabric.EgRect({
    left,
    top,
    height,
    width,
    strokeWidth: 2,
    selectable: true,
    isPrintFrame: true,
    strokeDashArray: [10, 10],
    stroke: 'red',
    fill: 'rgba(0,0,0,0)',
    hasBorders: false,
    cornerColor: 'red',
    cornerStrokeColor: 'red',
    transparentCorners: false,
    hasRotatingPoint: false,
    cornerSize: 18,
    excludeFromExport: true, // Jsonにした際に除外する
  });
  self._canvas.add(printFrame).setActiveObject(printFrame);
  self._canvas.requestRenderAll();
};

// 印刷範囲非表示
_drawing.prototype.hidePrintFrame = function(
  option = { selectHistoryTool: true }
) {
  var self = this;
  self._canvas.remove(self.findPrintFrame(self._canvas.getObjects()));
  self.canvasAllObjectsSelectableChange(true);
  if (option.selectHistoryTool) {
    ui.toolboxSelect(self.historyTool);
  }
};

// 印刷範囲確定
_drawing.prototype.savePrintRange = function() {
  var self = this;
  var printFrame = self.findPrintFrame(self._canvas.getObjects());
  var transformedPoint = self.getTransformedPoint();

  const printRange = {
    top: printFrame.top,
    left: printFrame.left,
    width: printFrame.width,
    height: printFrame.height,
    transformPx: transformedPoint.x - self._MAX_LEFT / 2,
    transformPy: transformedPoint.y - self._MAX_TOP,
  };
  self.printRange = printRange;

  // BLDE_V2-12013対応
  self.client.flush();
  self.client.flushPrintRange(printRange);
  // 現在(2019/05/16) PrintRange の実装中

  self.setBackgroundPrint(printRange);
};

// 印刷範囲をデフォルトに戻す
_drawing.prototype.backPrintFrameDefault = function() {
  var self = this;
  var printFrame = self.findPrintFrame(self._canvas.getObjects());
  printFrame.set({
    top: self._MIN_TOP,
    left: self._MIN_LEFT,
    width: self._MAX_LEFT,
    height: self._MAX_TOP,
  });
  printFrame.setCoords();
  self._canvas.requestRenderAll();
};

// Get transformed Point
_drawing.prototype.getTransformedPoint = function() {
  var self = this;
  var point = {
    x: self._MAX_LEFT / 2,
    y: self._MAX_TOP,
  };
  var invertedMatrix = fabric.util.invertTransform(
    self._canvas.viewportTransform
  );
  return fabric.util.transformPoint(point, invertedMatrix);
};

/**
 * 印刷範囲を設定する関数
 */
_drawing.prototype.setBackgroundPrint = function(printRange) {
  var self = this;
  self._canvas.remove(self.backgroundPrint);

  if (_.isEmpty(printRange)) {
    self.backgroundPrint.left = self._MIN_LEFT;
    self.backgroundPrint.top = self._MIN_TOP;
    self.backgroundPrint.height = self._MAX_TOP;
    self.backgroundPrint.width = self._MAX_LEFT;
  } else {
    self.backgroundPrint.left = printRange.left;
    self.backgroundPrint.top = printRange.top;
    self.backgroundPrint.height = printRange.height;
    self.backgroundPrint.width = printRange.width;
  }
  self._canvas.add(self.backgroundPrint);
  self.backgroundPrint.sendToBack();
  self._canvas.requestRenderAll();
};

/**
 * 印刷範囲を取得する関数
 */
_drawing.prototype.getPrintRange = function() {
  const self = this;
  return {
    top: self.backgroundPrint.top,
    left: self.backgroundPrint.left,
    height: self.backgroundPrint.height,
    width: self.backgroundPrint.width,
  };
};

// 印刷範囲を受信データの
// CanvasHeight, CanvasWidth, CanvasTop, CanvasLeft が含まれる
// オブジェクトから取得して
// Height Width Top Left が 全て有効値
// そして Height Width がどちらも 0 ではないなら
// printRange を設定する。それ以外は null
export const getPrintRangeFromCanvas = CanvasData => {
  let printRange = null;
  const { CanvasHeight, CanvasWidth, CanvasTop, CanvasLeft } = CanvasData;
  if (
    [CanvasHeight, CanvasWidth, CanvasTop, CanvasLeft].every(value =>
      Number.isFinite(value)
    )
  ) {
    const height = Number(CanvasHeight);
    const width = Number(CanvasWidth);
    if (CanvasHeight !== 0 && CanvasWidth !== 0) {
      printRange = {
        height,
        width,
        top: Number(CanvasTop),
        left: Number(CanvasLeft),
      };
    }
  }
  return printRange;
};

// ポイントの補正
_drawing.prototype.formatVertices = function(points) {
  var START_POINT = -0.25;
  var END_POINT = 0.25;
  var point = {};
  var maxPoints = 0;
  var vertices = [];
  if (util.getDevice() === 'other') {
    var pointEnd = points.pop();
    maxPoints = points ? points.length : 0;
    for (var i = 0; i < maxPoints; i++) {
      point = points[i];
      if (
        (point.x === START_POINT && point.y === START_POINT) ||
        (point.x === END_POINT && point.y === END_POINT)
      ) {
        continue;
      }
      vertices.push(point);
      if (point.x === pointEnd.x && point.y === pointEnd.y) {
        break;
      }
    }
  } else {
    var pointCheck = {};
    maxPoints = points ? points.length : 0;
    for (var i = 0; i < maxPoints; i++) {
      point = points[i];
      if (
        (point.x === START_POINT && point.y === START_POINT) ||
        (point.x === END_POINT && point.y === END_POINT)
      ) {
        continue;
      }
      if (
        i + 1 === maxPoints &&
        Math.abs(point.x) < 5 &&
        Math.abs(point.y) < 5
      ) {
        continue;
      }
      // 1つ前の頂点との差分が少ない場合は、その頂点をスキップしている タブレットの操作性の問題だと思われる
      pointCheck = vertices[vertices.length - 1] || {};
      if (
        (pointCheck.x === point.x && pointCheck.y === point.y) ||
        (Math.abs(pointCheck.x - point.x) < 5 &&
          Math.abs(pointCheck.y - point.y) < 5)
      ) {
        continue;
      }
      vertices.push(point);
    }
  }

  return vertices;
};

_drawing.prototype.getLeftTop = function(vertices, strokeWidth) {
  if (vertices && vertices.length === 0) {
    return null;
  }
  var widthRadius = strokeWidth === 1 ? 0 : strokeWidth / 2;
  var leftTop = {
    left: vertices[0].x,
    top: vertices[0].y,
  };
  _.each(vertices, function(vertice) {
    if (leftTop.left > vertice.x) {
      leftTop.left = vertice.x;
    }
    if (leftTop.top > vertice.y) {
      leftTop.top = vertice.y;
    }
  });
  leftTop.left = Math.floor(leftTop.left) - widthRadius;
  leftTop.top = Math.floor(leftTop.top) - widthRadius;

  return leftTop;
};

_drawing.prototype.getObjectPropertiesInGroup = function(group, object) {
  const center = group.getCenterPoint();
  const rad = fabric.util.degreesToRadians(group.angle);
  const point = fabric.util.rotatePoint(
    new fabric.Point(object.left, object.top),
    new fabric.Point(0, 0),
    rad
  );
  let flipX = object.flipX;
  let flipY = object.flipY;
  let left = center.x + point.x;
  let top = center.y + point.y;
  if (group.flipX) {
    flipX = !object.flipX;
    left = center.x - point.x;
    if (object.type !== 'egGroup') {
      left -= object.width;
    }
  }
  if (group.flipY) {
    flipY = !object.flipY;
    top = center.y - point.y;
    if (object.type !== 'egGroup') {
      top -= object.height;
    }
  }
  const angle = group.angle + object.angle;
  return {
    top,
    left,
    flipX,
    flipY,
    angle,
  };
};

_drawing.prototype.removeVertices = function(defaultFlag, toolBox) {
  var self = this;
  var canvasObjects = self._canvas.getObjects();
  var deleteElement = [];
  if (canvasObjects.length > 0) {
    var maxLength = canvasObjects.length;
    var element = null;
    for (var i = 0; i < maxLength; i++) {
      element = canvasObjects[i];
      if (defaultFlag) {
        if (
          element.type === 'egPolygon' ||
          element.type === 'egPolyline' ||
          element.type === 'egLine'
        ) {
          element.set({
            selectable: true,
            hasControls: true,
            hasBorders: true,
          });
          delete element['objectCaching'];
        }
      }
      if (!element.isEditPoint && !element.isVirtualLine) {
        continue;
      }
      deleteElement.unshift(i);
    }
    _.each(deleteElement, function(element) {
      canvasObjects.splice(element, 1);
    });
    if (defaultFlag && deleteElement.length > 0) {
      self._toolbox_selected = toolBox != null ? toolBox : 'tool-select';
      self._canvas.requestRenderAll();
    }
  }
};

// Show point at vertex of polygon, polyline and line
_drawing.prototype.addPoints = function(drawObject) {
  if (typeof drawObject.points === 'undefined' || drawObject.points == null) {
    return;
  }
  let offSetX = 0;
  let offSetY = 0;
  if (drawObject.type !== 'egLine') {
    offSetX = drawObject.pathOffset.x;
    offSetY = drawObject.pathOffset.y;
  }
  const strokeWidth =
    drawObject.strokeWidth <= 14 ? 7 : drawObject.strokeWidth / 2;
  const matrix = drawObject.calcTransformMatrix();
  // pointsから座標の変換はhttps://stackoverflow.com/a/39072194を参考
  _(drawObject.points)
    .map(p => {
      return new fabric.Point(p.x - offSetX, p.y - offSetY);
    })
    .map(p => {
      return fabric.util.transformPoint(p, matrix);
    })
    .map((p, i) => {
      return new fabric.EgEllipse({
        radius: strokeWidth,
        fill: '#9A56ED',
        top: p.y,
        left: p.x,
        rx: strokeWidth,
        ry: strokeWidth,
        originX: 'center',
        originY: 'center',
        hasBorders: false,
        hasControls: false,
        isEditPoint: true,
        pointIndex: i,
        pointTotal: drawObject.points.length,
        poly: drawObject,
        leftLine: null,
        rightLine: null,
        excludeFromExport: true, // Jsonにした際に除外する マーカーを削除するために設定（編集中にリロードすると残るための処置）
      });
    })
    .each(circle => this._canvas.add(circle));
};

// Enable vertex edit for polygon, polyline and line
_drawing.prototype.showEditPoints = function() {
  var self = this;
  self._target = self._canvas.getActiveObject();
  if (self._target) {
    switch (self._target.get('type')) {
      case 'egLine':
      case 'egPolygon':
      case 'egPolyline':
      case 'egSector':
        if (self._target.locked !== 0) {
          return;
        }
        if (
          self._toolbox_selected === 'tool-select' ||
          $('[data-id="tool-select"]')[0].classList.contains('selected')
        ) {
          const activeObject = self._canvas.getActiveObject();
          self._toolbox_selected = 'tool-point';

          activeObject.set({
            selectable: false,
            objectCaching: false,
            hasControls: false,
            hasBorders: false,
          });

          if (self._target.get('type') === 'egLine') {
            // Recalculates line points
            const points = activeObject.calcLinePoints();
            activeObject.points = [
              {
                x: points.x1,
                y: points.y1,
              },
              {
                x: points.x2,
                y: points.y2,
              },
            ];
          } else if (
            self._target.get('type') === 'egPolygon' ||
            self._target.get('type') === 'egPolyline'
          ) {
            activeObject.points = [];
            _.each(activeObject._stateProperties.points, point => {
              activeObject.points.push({
                x: point.x,
                y: point.y,
              });
            });
          }
          // >>>-----------------------------------------------------------
          // BLDE_V2-16873 編集マーカーが選択線の中にあると編集できない問題があった。
          // それを対応するために以下の処理にて操作可能になるようにした。
          // 修正理由は、canvasの重なり順は追加順（後が上の模様）のようで、
          // 既存処理でも対象オブジェクトとマーカーの付け直しをしていたので、
          // そのロジックをダブルクリック時に走るよう修正した。
          var self = this;
          var canvasObjects = self._canvas.getObjects();
          var objStateBefore = fabric.eg.getFromUuid(activeObject.uuid);
          var index = canvasObjects.indexOf(activeObject);

          const options = activeObject.toObject();
          delete options['points'];

          let drawObject;
          if (activeObject.type === 'egPolygon') {
            drawObject = new fabric.EgPolygon(activeObject.points, options);
          } else if (activeObject.type === 'egPolyline') {
            drawObject = new fabric.EgPolyline(activeObject.points, options);
          } else if (activeObject.type === 'egSector') {
            drawObject = new fabric.EgSector(activeObject.path, options);

            activeObject.points = [];
            _.each(activeObject.path, pathSegment => {
              const [command, ...coords] = pathSegment;
              if (command === 'L') {
                activeObject.points.push({
                  x: coords[0],
                  y: coords[1],
                });
              } else if (command === 'A') {
                activeObject.points.push({
                  x: coords[5],
                  y: coords[6],
                });
              }
            });
            // To use func addPoints
            drawObject.points = activeObject.points;
          } else {
            drawObject = new fabric.EgLine(
              [
                activeObject.points[0].x,
                activeObject.points[0].y,
                activeObject.points[1].x,
                activeObject.points[1].y,
              ],
              options
            );
            // To use func addPoints
            drawObject.points = activeObject.points;
          }
          self.batchRender(() => {
            self._canvas.remove(activeObject);
            self._canvas.add(drawObject);
            drawObject._stateProperties = objStateBefore._stateProperties;
            // BLDE_V2-27919: 描画されたオブジェクト一覧でオブジェクトを現在のレベルに移動する
            self._canvas.moveTo(drawObject, index);
            self.removeVertices(false, null);
            self.addPoints(drawObject);
          });
          self.client.push(drawObject);
          // <<<-----------------------------------------------------------
        }
        break;
      default:
        break;
    }
  }
};

// Handle change lines when editing vertex of polygon, polyline and line
_drawing.prototype.changeLines = function(vertices) {
  var center = vertices.getCenterPoint();
  var leftLine = vertices.leftLine;
  var rightLine = vertices.rightLine;

  if (vertices.poly.type === 'egSector') {
    const currentLine = vertices.pointIndex === 0 ? leftLine : rightLine;
    const R = vertices.poly.width / 2;
    const newPoint = intersectionPointOfCircleAndLine(
      currentLine.x2,
      currentLine.y2,
      R,
      center.x,
      center.y
    );

    currentLine
      .set({
        x1: newPoint[0],
        y1: newPoint[1],
      })
      .setCoords();
    let offSetX = 0;
    let offSetY = 0;
    const drawObject = vertices.poly;
    if (drawObject.type !== 'egLine') {
      offSetX = drawObject.pathOffset.x;
      offSetY = drawObject.pathOffset.y;
    }
    const matrix = drawObject.calcTransformMatrix();
    // pointsから座標の変換はhttps://stackoverflow.com/a/39072194を参考

    var self = this;
    var canvasObjects = self._canvas.getObjects();
    var index = canvasObjects.indexOf(vertices);
    const newP = new fabric.Point(
      currentLine.x1 - offSetX,
      currentLine.y1 - offSetY
    );
    fabric.util.transformPoint(newP, matrix);
    canvasObjects[index]
      .set({
        top: newP.y,
        left: newP.x,
      })
      .setCoords();
  } else {
    if (leftLine != null) {
      leftLine
        .set({
          x2: center.x,
          y2: center.y,
        })
        .setCoords();
    }
    if (rightLine != null) {
      rightLine
        .set({
          x2: center.x,
          y2: center.y,
        })
        .setCoords();
    }
  }
};

// Create the virtual lines
_drawing.prototype.drawVirtualLines = function(vertexObject) {
  var self = this;
  var leftPoint = null;
  var rightPoint = null;
  var leftLine = null;
  var rightLine = null;
  var canvasObjects = self._canvas.getObjects();
  var center = vertexObject.getCenterPoint();
  var index = canvasObjects.indexOf(vertexObject);
  var typeEdit = vertexObject.poly.type;
  var maxPoint = vertexObject.pointTotal - 1;
  var options = {
    stroke: '#9A56ED',
    strokeWidth: 2,
    strokeDashArray: [10, 5, 3, 5],
    selectable: false,
    hasControls: false,
    hasBorders: false,
    isVirtualLine: true,
  };

  switch (typeEdit) {
    case 'egPolygon':
      if (vertexObject.pointIndex === 0) {
        leftPoint = canvasObjects[index + maxPoint].getCenterPoint();
        rightPoint = canvasObjects[index + 1].getCenterPoint();
      } else if (vertexObject.pointIndex === maxPoint) {
        leftPoint = canvasObjects[index - 1].getCenterPoint();
        rightPoint = canvasObjects[index - maxPoint].getCenterPoint();
      } else {
        leftPoint = canvasObjects[index - 1].getCenterPoint();
        rightPoint = canvasObjects[index + 1].getCenterPoint();
      }
      break;
    case 'egPolyline':
      if (vertexObject.pointIndex === 0) {
        rightPoint = canvasObjects[index + 1].getCenterPoint();
      } else if (vertexObject.pointIndex === maxPoint) {
        leftPoint = canvasObjects[index - 1].getCenterPoint();
      } else {
        leftPoint = canvasObjects[index - 1].getCenterPoint();
        rightPoint = canvasObjects[index + 1].getCenterPoint();
      }
      break;
    case 'egSector':
      index -= vertexObject.pointIndex;
      center = vertexObject.poly.getCenterPoint();
      leftPoint = canvasObjects[index].getCenterPoint();
      rightPoint = canvasObjects[index + 1].getCenterPoint();
      break;
    case 'egLine':
      if (vertexObject.pointIndex === 0) {
        rightPoint = canvasObjects[index + 1].getCenterPoint();
      } else {
        leftPoint = canvasObjects[index - 1].getCenterPoint();
      }
      break;
    default:
      break;
  }
  if (leftPoint != null) {
    leftLine = new fabric.EgLine(
      [leftPoint.x, leftPoint.y, center.x, center.y],
      options
    );
    self._canvas.add(leftLine);
  }
  if (rightPoint != null) {
    rightLine = new fabric.EgLine(
      [rightPoint.x, rightPoint.y, center.x, center.y],
      options
    );
    self._canvas.add(rightLine);
  }
  vertexObject.set({
    leftLine,
    rightLine,
  });
};
// Remove edit points polyline/polygon/straight line after finish edit mode
_drawing.prototype.removeEditPoints = function() {
  let editPoints = [];
  const self = this;
  self._canvas.forEachObject(function(o) {
    if (o.isEditPoint) {
      editPoints.push(o);
    }
  });
  if (editPoints.length > 0) {
    _.forEach(editPoints, function(value) {
      self._canvas.remove(value);
    });
    self._canvas.requestRenderAll();
    self.updateObjectCount();
  }
};

// Get vertices edit from edited point
_drawing.prototype.getEditPoints = function(objects) {
  return _(objects)
    .filter(o => o.isEditPoint)
    .map(o => o.getCenterPoint())
    .value();
};

// Handle redraw for Polygon, Polyline, Straight Line
_drawing.prototype.handleEgObject = function(drawObject) {
  var self = this;
  var canvasObjects = self._canvas.getObjects();
  var points = self.getEditPoints(canvasObjects);
  if (points.length === 0) {
    return drawObject;
  }

  var index = canvasObjects.indexOf(drawObject);

  let { left, top, width, height } = drawObject;
  if (drawObject.type !== 'egSector') {
    const leftTop = self.getLeftTop(points, drawObject.strokeWidth);
    drawObject.set({
      left: leftTop.left,
      top: leftTop.top,
      angle: 0,
    });
  } else {
    const radius = width / 2 + drawObject.strokeWidth / 2;
    const newCenter = findSectorPointByAngle(
      [left, top],
      [left + Math.sqrt(2) * radius, top],
      fabric.util.degreesToRadians(drawObject.angle + 45)
    );
    left = newCenter[0] - radius;
    top = newCenter[1] - radius;
    drawObject.set({
      left,
      top,
      width,
      height,
      angle: 0,
    });
  }

  const options = drawObject.toObject();
  delete options['points'];
  options.originX = 'left';
  options.originY = 'top';
  options.flipX = false;
  options.flipY = false;
  self._canvas.remove(drawObject);
  var objStateBefore = fabric.eg.getFromUuid(drawObject.uuid);
  if (drawObject.type === 'egPolygon') {
    drawObject = new fabric.EgPolygon(points, options);
  } else if (drawObject.type === 'egPolyline') {
    drawObject = new fabric.EgPolyline(points, options);
  } else if (drawObject.type === 'egSector') {
    const radius = width / 2;
    const centerPoint = [0, 0];
    if (drawObject.flipX ^ drawObject.flipY) {
      points.reverse();
    }
    const point1 = [
      points[0].x - left - radius - drawObject.strokeWidth / 2,
      points[0].y - top - radius - drawObject.strokeWidth / 2,
    ];
    const point2 = [
      points[1].x - left - radius - drawObject.strokeWidth / 2,
      points[1].y - top - radius - drawObject.strokeWidth / 2,
    ];
    const newPoint1 = intersectionPointOfCircleAndLine(
      0,
      0,
      radius,
      point1[0],
      point1[1]
    );
    const newPoint2 = intersectionPointOfCircleAndLine(
      0,
      0,
      radius,
      point2[0],
      point2[1]
    );

    const sectorAngle = calcAngle(centerPoint, newPoint1, newPoint2);

    drawObject = new fabric.EgSector(
      `M ${-radius} ${-radius} M ${radius} ${radius} M ${centerPoint[0]} ${
        centerPoint[1]
      } L ${newPoint1[0]} ${newPoint1[1]} A ${radius} ${radius} 0 ${
        sectorAngle > Math.PI ? 1 : 0
      } 1 ${newPoint2[0]} ${newPoint2[1]} Z`,
      options
    );
  } else {
    drawObject = new fabric.EgLine(
      [points[0].x, points[0].y, points[1].x, points[1].y],
      options
    );
    drawObject.setCoords();
  }

  self._canvas.add(drawObject);
  // BLDE_V2-27919: 描画されたオブジェクト一覧でオブジェクトを現在のレベルに移動する
  self._canvas.moveTo(drawObject, index);
  drawObject._stateProperties = objStateBefore._stateProperties;
  self.removeVertices(false, null);

  return drawObject;
};

/**
 * オブジェクトのディープコピー(クローン)
 */
_drawing.prototype.deepCloneObjectAsync = async function(sourceObject) {
  // fabricのobjectにはcloneメソッドが実装されているので使う egは拡張している
  // fabric.util.object.cloneは使用してもイベントがクローンされない
  return new Promise(resolve => {
    sourceObject.clone(clonedObject => {
      resolve(clonedObject);
    });
  });
};

/**
 * 印刷範囲オブジェクトがキャンバス内にある場合return
 */
_drawing.prototype.findPrintFrame = canvasObjects => {
  return _.find(canvasObjects, canvas => canvas.isPrintFrame === true);
};

_drawing.prototype.moveObject = function(action) {
  var self = this;
  console.log('debug', 'moveObject', action);
  switch (action) {
    case 'left':
      self._target.left = self._target.left - 1;
      break;
    case 'top':
      self._target.top = self._target.top - 1;
      break;
    case 'right':
      self._target.left = self._target.left + 1;
      break;
    case 'bottom':
      self._target.top = self._target.top + 1;
      break;
    case 'commit':
      self._canvas.trigger('object:modified', { target: self._target });
      break;
  }
  self._canvas.requestRenderAll();
};

// debug用
_drawing.prototype.debug = function(...str) {
  if (str.length === 0) {
    return;
  }
  // eslint-disable-next-line no-unused-vars
  const messageTitle = str[0];
  str.splice(0, 1);
  console.log(`debug ${messageTitle}`, ...str);
};

_drawing.prototype.batchRender = function(renderF) {
  // renderOnAddRemoveがtrueだとcanvasに追加削除したタイミングでレンダリングされる
  // falseにするとレンダリングのタイミングを制御できる
  // 使った方が速いので使える箇所は使っていくようにする
  this._canvas.renderOnAddRemove = false;
  renderF();
  this._canvas.requestRenderAll();
  this._canvas.renderOnAddRemove = true;
};

_drawing.prototype.isObjectCountLimitExceeded = function() {
  const objectCount = this.getObjectCount(this._canvas.getObjects());
  return objectCount > this._object_max_count;
};

// 現場配置計画から離れる際や場所変更時に呼ばれる
_drawing.prototype.beforeExitConstructionPlacementPlaces = async function() {
  // 手書き中に離れた場合今書いているものをオブジェクト化する
  if (drawing._toolbox_selected === 'tool-freehand') {
    await penEnd({
      fabricCanvas: drawing._canvas,
    })
  }
  // 手書きのカラーパレットをリセットする
  window.dispatchEvent(new Event('resetFreehandPalette'));
}

// 選択オブジェクトに図形が含まれるかどうか
_drawing.prototype.selectionHasShape = function() {
  if (drawing._target._objects) {
    return drawing._target._objects.some(o => drawing._shapes.includes(o.type))
  }
  return drawing._shapes.includes(drawing._target.type);
}

const checkObjectCount = canvas => {
  return canvas.getObjects().length < drawing._object_max_count;
};

const sortObjectsByIndex = (self, history) => {
  if (_.isEmpty(history.sortedUUIDs)) {
    return;
  }
  self._canvas.forEachObject(obj => {
    const index = history.sortedUUIDs.indexOf(obj.uuid);
    if (index !== -1) {
      self._canvas.moveTo(obj, index);
    }
  });
};

const calcAngle = (centerPoint, point1, point2) => {
  const angle1 = Math.atan2(
    point1[1] - centerPoint[1],
    point1[0] - centerPoint[0]
  );
  const angle2 = Math.atan2(
    point2[1] - centerPoint[1],
    point2[0] - centerPoint[0]
  );

  let result = angle2 - angle1;

  // # Adjust the arc angle to approx [0, 2*pi]
  while (result < 0) {
    result += 2 * Math.PI;
  }
  while (result > 2 * Math.PI) {
    result -= 2 * Math.PI;
  }

  return result;
};

export const drawing = new _drawing();



// WEBPACK FOOTER //
// ./src/canvas/common/drawing.js